import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "../ShipmentSelectScanType.css";
import { ToastContainer, toast } from "react-toastify";
import "jspdf-autotable";

import { UserContext } from "../../common/UserContext";
import config from "../../../envconfig";
import Select from "react-select";
import { IoCaretDownOutline, IoCaretUpOutline } from "react-icons/io5";

function ShipOutScanByVendor() {
  const {
    UM_CompanyGrpID,
    selectedScpId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
  } = useContext(UserContext);

  const { SHPH_ShipmentID } = useParams();
  const navigate = useNavigate();
  const [RSN, setRSN] = useState("");
  const [UniqueRSN, setUniqueRSN] = useState(new Set());
  const [SelectedShipmentID, setSelectedShipmentID] = useState(null);
  const [SelectedProductID, setSelectedProductID] = useState(null);
  const [CheckedItems, setCheckedItems] = useState(new Set());
  const [SCPNames, setSCPNames] = useState([]);
  const [ShipmentsBySCP, setShipmentsBySCP] = useState([]);
  const [SelectedProduct, setSelectedProduct] = useState("");
  const [ExtractedGTIN, setExtractedGTIN] = useState(null);
  const [selectedShipmentsBySCP, setSelectedShipmentsBySCP] = useState([]);
  const [ScannedResultForSCP, setScannedResultForSCP] = useState(null);
  const [shipRandomrsn, setShipRandomrsn] = useState({ getparentrsn: "" });
  const [fetchedData, setFetchedData] = useState("");
  const [notAddedValues, setNotAddedValues] = useState([]);
  const [isRSNScanned, setIsRSNScanned] = useState(false);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false); // Step 1: Track button click state
  const [manualInputEnabled, setManualInputEnabled] = useState(false);
  const [isGift,setisGift] = useState();
  console.log("isgift",isGift)
  const [inputMode, setInputMode] = useState("scan"); // "scan" or "manual"
  const inputRef = useRef(null); // Add useRef to reference the input element
  const debounceTimer = useRef(null);

  //================================================================================
  // Scheme Related
  const [isSpecialPopupVisible, setIsSpecialPopupVisible] = useState(false);
  const [specialPopupMessage, setSpecialPopupMessage] = useState("");
  const [shipmentSpecialData, setShipmentSpecialData] = useState({});
  //================================================================================

const [loading, setLoading] = useState(false);
const [refreshTrigger, setRefreshTrigger] = useState(0);


const [rsnTree, setRsnTree] = useState(null);
const [expandedNodes, setExpandedNodes] = useState(new Set());

const renderRSNNode = (node, level = 0, isRoot = false, insideBox = false) => {
  const hasChildren = node.children && node.children.length > 0;
  const isExpanded = expandedNodes.has(node.IRS_RandomNo);

  return (
    <div key={node.IRS_RandomNo} style={{ marginLeft: level * 20 }}>
      {/* Root Node */}
      {isRoot ? (
        <>
          <input
            className="form-check-input"
            type="checkbox"
            checked={CheckedItems.has(node.IRS_RandomNo)}
            onChange={(e) => handleCheckBoxChange(e, node.IRS_RandomNo)}
            value={node.IRS_RandomNo}
            id={`check-${node.IRS_RandomNo}`}
          />
          <label
            className="form-check-label"
            htmlFor={`check-${node.IRS_RandomNo}`}
            style={{ color: "#465a64", marginLeft: "6px" }}
          >
            {node.IRS_RandomNo}
          </label>

          {/* Expand/Collapse button for root */}
          {hasChildren && (
            <button
              type="button"
              className="btn btn-link btn-sm"
              style={{ fontSize: "12px", padding: "2px 6px", marginLeft: "6px" }}
              onClick={() => {
                const newExpanded = new Set(expandedNodes);
                if (isExpanded) newExpanded.delete(node.IRS_RandomNo);
                else newExpanded.add(node.IRS_RandomNo);
                setExpandedNodes(newExpanded);
              }}
            >
              {isExpanded ? "➖" : "➕"}
            </button>
          )}
        </>
      ) : (
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* Always reserve space for expand/collapse if inside box */}
          {insideBox && (
            <div style={{ width: "18px", textAlign: "center" }}>
              {hasChildren ? (
                <button
                  type="button"
                  className="btn btn-link btn-sm"
                  style={{
                    fontSize: "12px",
                    padding: "1px 3px",
                    lineHeight: "1",
                  }}
                  onClick={() => {
                    const newExpanded = new Set(expandedNodes);
                    if (isExpanded) newExpanded.delete(node.IRS_RandomNo);
                    else newExpanded.add(node.IRS_RandomNo);
                    setExpandedNodes(newExpanded);
                  }}
                >
                  {isExpanded ? "➖" : "➕"}
                </button>
              ) : (
                <span style={{ display: "inline-block", width: "12px" }} />
              )}
            </div>
          )}

          {/* Label */}
          <span style={{ color: "#465a64", marginLeft: "6px" }}>
            {node.IRS_RandomNo}
          </span>
        </div>
      )}

      {/* Children */}
      {hasChildren && isExpanded && (
        <div
          style={{
            marginTop: 6,
            border: isRoot ? "1px solid #ccc" : "none",
            borderRadius: isRoot ? "6px" : "0",
            padding: isRoot ? "10px" : "0",
          }}
        >
          {node.children.map((child) =>
            renderRSNNode(child, level + 1, child.isRoot, true) // insideBox = true
          )}
        </div>
      )}
    </div>
  );
};

  
  const logAction = async (action, isError = false) => {
    try { // API_URL
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: `Shipment Outward Scanning By Vendor :`,
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };
  //====================================================================

  //============================= Audit Trail ==========================
  const audittransection = async (data) => {
    const formData = {
      AUTRN_ID: data.AUTRN_ID,
      AUTRN_OldValue: data.AUTR_NewValue ?? null,
      AUTRN_NewValue: data.AUTRN_NewValue,
      AUTRN_ParamererName: data.AUTRN_ParamererName,
    };
    try {
      const response = await axios.post(
        `${config.API_URL}/api/audittransaction`,
        formData
      );
      // alert('Data inserted successfully');
    } catch (error) {
      if (error.response) {
        console.error("Server responded with an error:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up the request:", error.message);
      }
    }
  };

  const audittrailpost = async (details) => {
    const getCurrentTimestamp = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // months are zero-indexed
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const currentTimestamp = getCurrentTimestamp();
    const AUTR_OldValue = details?.AUTR_OldValue ?? null;
    const AUTR_NewValue = details?.AUTR_NewValue ?? null;
    const AUTR_Message = details.AUTR_Message;
    const AUTR_AuditType = details.AUTR_AuditType;
    if (
      UM_CompanyID === null ||
      UM_CompanyID === "null" ||
      UM_CompanyGrpID === null ||
      UM_CompanyGrpID === "null" ||
      selectedScpId === null ||
      selectedScpId === "null"
    ) {
      console.log("null--------");
      const data = {
        AUTR_ScreenName: "Shipment Outward Scanning",
        AUTR_OldValue: AUTR_OldValue,
        AUTR_NewValue: AUTR_NewValue,
        AUTR_Message: AUTR_Message,
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: AUTR_AuditType,
        AUTR_SCPID: null,
        AUTR_CompanyGrpId: null,
        AUTR_CompanyID: null,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp,
      };
      console.log(data);
      try {
        const response = await axios.post(
          `${config.API_URL}/api/audittrail`,
          data
        );
        console.log("Success:", response.data);
        return response.data;
      } catch (error) {
        console.error("Error:", error);
      }
    } else {
      console.log("null--------");
      const data = {
        AUTR_ScreenName: "Shipment Outward Scanning",
        AUTR_OldValue: AUTR_OldValue,
        AUTR_NewValue: AUTR_NewValue,
        AUTR_Message: AUTR_Message,
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: AUTR_AuditType,
        AUTR_SCPID: selectedScpId,
        AUTR_CompanyGrpId: UM_CompanyID,
        AUTR_CompanyID: UM_CompanyID,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp,
      };
      console.log(data);
      try {
        const response = await axios.post(
          `${config.API_URL}/api/audittrail`,
          data
        );
        console.log("Success:", response.data);
        return response.data;
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  //====================================================================


useEffect(() => {
  const fetchSCPNames = async () => {
    try {
      const response = await axios.get(
        `${config.API_URL}/SCP_Code_vendor/${SHPH_ShipmentID}`
      );
      const data = response.data;
      console.log("ShipmentData-", data);
      setisGift(data);
      
      if (response.status === 200) {
        const uniqueSCPNames = Array.from(
          new Set(
            data.SCPM_Name.map((scpName) => ({
              value: scpName.SCPM_Name,
              label: scpName.SCPM_Name,
            }))
          )
        );
        setSCPNames(uniqueSCPNames);

        // Auto-select the first SCP from the dropdown
        if (uniqueSCPNames.length > 0 && !SelectedProduct) {
          const firstSCP = uniqueSCPNames[0];
          setSelectedProduct(firstSCP.value);
          
        }
      } else {
        console.error("Error fetching SCP Names:", data.error);
        toast.error("Failed to fetch SCP Names");
      }
    } catch (error) {
      console.error("Failed to fetch SCP Names:", error);
      toast.error("Failed to fetch SCP Names");
    }
  };

  fetchSCPNames();
}, [SHPH_ShipmentID]);
 
const handleAutoSCPSelection = (selectedProductValue) => {
  if (selectedProductValue && ShipmentsBySCP.length > 0) {
    const filteredShipmentsBySCP = ShipmentsBySCP.filter(
      (shipment) => shipment.SCPM_Name === selectedProductValue
    );

    const existingSCPIds = new Set(
      selectedShipmentsBySCP.map((item) => `${item.SCPM_Name}-${item.SHPD_ProductCode}`)
    );
    
    const newItems = filteredShipmentsBySCP.filter(
      (item) => !existingSCPIds.has(`${item.SCPM_Name}-${item.SHPD_ProductCode}`)
    );
    
    if (newItems.length > 0) {
      setSelectedShipmentsBySCP((prevShipmentsBySCP) => [
        ...prevShipmentsBySCP,
        ...newItems,
      ]);

      // Store Updated Data in session storage
      const updatedData = [...selectedShipmentsBySCP, ...newItems];
      sessionStorage.setItem("shipmentTableData", JSON.stringify(updatedData));
    }
  }

  // Update SCPNames to mark as disabled
  setSCPNames((prevSCPNames) =>
    prevSCPNames.map((option) =>
      option.value === selectedProductValue
        ? { ...option, isDisabled: true }
        : option
    )
  );
  
  setManualInputEnabled(false);
};
  //====================================================================

useEffect(() => {
  const fetchAllData = async () => {
    try {
//========== Newly Added ============
      const storedData = sessionStorage.getItem('shipmentTable');
       if (storedData) {
        const parsedData = JSON.parse(storedData);
        setSelectedShipmentsBySCP(parsedData);
        return; 
       }
//===================================
      // 1. Fetch data from Shipmentlist_vendor API
      const shipmentResponse = await axios.get(
        `${config.API_URL}/Shipmentlist_vendor/${SHPH_ShipmentID}`
      );
      const shipmentData = shipmentResponse.data.shipmentData;
      logAction(`Shipment list fetched successfully`);
      // Check for special scheme values
      const hasSpecialScheme = shipmentData.some(item => 
        item.OSM_SM_Value && item.SM_GiftArticle
      );
      
      if (hasSpecialScheme) {
        // Store the special data for later use
        const specialItems = shipmentData.filter(item => 
          item.OSM_SM_Value && item.SM_GiftArticle
        );
        setShipmentSpecialData(specialItems);
      
      }

      // 2. Fetch RSN PackSize data
      const scannedRSNResponse = await axios.get(
        `${config.API_URL}/Scanned_RSN_PackSize_OF_Shipment_Outward/${SHPH_ShipmentID}/${selectedScpId}`
      );
      const rsnPackSizeData = scannedRSNResponse.data.AllRSN_ToOutward;

      // 3. Fetch scanned RSN list
      const scannedRandomNoResponse = await axios.get(
        `${config.API_URL}/Scanned_RSN_OF_Shipment_Outward/${SHPH_ShipmentID}/${selectedScpId}`
      );
      const rsnRandomNoData = scannedRandomNoResponse.data.AllRSN_ToOutward;

      // --- merge shipment data (your old logic) ---
      const shipmentMap = {};
      shipmentData.forEach((shipment) => {
        const matchedRSN = rsnPackSizeData.find(
          (rsn) =>
            rsn.PL_ProductCode === shipment.SHPD_ProductCode &&
            rsn.IRS_ToSCP === shipment.SHPD_SCPCode
        );
        const key = `${shipment.SHPD_ProductCode}-${shipment.SHPD_SCPCode}`;
        if (!shipmentMap[key]) {
          shipmentMap[key] = {
            ...shipment,
            SHPD_ShipQty: shipment.SHPD_ShipQty,
            SHPD_ScanQty: matchedRSN
              ? shipment.SHPD_ScanQty + matchedRSN.IRS_PackSize
              : shipment.SHPD_ScanQty,
          };
        } else {
          shipmentMap[key].SHPD_ShipQty += shipment.SHPD_ShipQty;
          shipmentMap[key].SHPD_ScanQty += shipment.SHPD_ScanQty;
        }
      });

      const mergedData = Object.values(shipmentMap);
      setShipmentsBySCP(mergedData);

      const rsnTreeDataRaw = await Promise.all(
        rsnRandomNoData.map(async (rsn) => {
          const resp = await axios.get(
            `${config.API_URL}/RSNChainToMap/${rsn.IRS_RandomNo}`
          );
          return resp.data.data; // recursive tree from backend
        })
      );
      
      // 🔥 Deduplicate by IRS_RandomNo
      const uniqueTreeData = [];
      const seen = new Set();
      for (const node of rsnTreeDataRaw) {
        if (!seen.has(node.IRS_RandomNo)) {
          seen.add(node.IRS_RandomNo);
          uniqueTreeData.push(node);
        }
      }
      
      setRsnTree(uniqueTreeData); // save unique tree in state

    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };

  if (selectedScpId) {
    fetchAllData();
  }
}, [SHPH_ShipmentID, selectedScpId, refreshTrigger]);

//====================================================================

// ADD THIS NEW USEEFFECT HOOK FOR AUTO-SELECTION
useEffect(() => {
  if (selectedShipmentsBySCP.length > 0) {
    // If nothing is selected, auto-select the first available product
    if (!SelectedShipmentID && !SelectedProductID) {
      const firstAvailableProduct = selectedShipmentsBySCP.find(
        shipment => shipment.SHPD_ShipQty > shipment.SHPD_ScanQty
      );
      
      if (firstAvailableProduct) {
        setSelectedShipmentID(firstAvailableProduct.SHPD_ShipmentMID);
        setSelectedProductID(firstAvailableProduct.PL_ProductId);
        console.log("Auto-selected first product:", {
          shipmentId: firstAvailableProduct.SHPD_ShipmentMID,
          productId: firstAvailableProduct.PL_ProductId,
          productName: firstAvailableProduct.SHPD_ProductName
        });
      }
    } 
    // Auto-switch to next available product when current one is saved
    else {
      const currentShipment = selectedShipmentsBySCP.find(
        shipment => shipment.SHPD_ShipmentMID === SelectedShipmentID
      );
      
      if (currentShipment && currentShipment.SHPD_ShipQty === currentShipment.SHPD_ScanQty) {
        const nextAvailableProduct = selectedShipmentsBySCP.find(
          shipment => 
            shipment.SHPD_ShipQty > shipment.SHPD_ScanQty && 
            shipment.SHPD_ShipmentMID !== SelectedShipmentID
        );
        
        if (nextAvailableProduct) {
          setSelectedShipmentID(nextAvailableProduct.SHPD_ShipmentMID);
          setSelectedProductID(nextAvailableProduct.PL_ProductId);
          console.log("Auto-switched to next product:", {
            shipmentId: nextAvailableProduct.SHPD_ShipmentMID,
            productId: nextAvailableProduct.PL_ProductId,
            productName: nextAvailableProduct.SHPD_ProductName
          });
          
        }
      }
    }
  }
}, [selectedShipmentsBySCP, SelectedShipmentID, SelectedProductID]);

//====================================================================
const checkScanCompletionAndShowPopup = (updatedShipments) => {
  // Check if any shipment with special scheme has reached scan completion
  const completedSpecialShipments = updatedShipments.filter(shipment => {
    const hasSpecialScheme = shipment.OSM_SM_Value && shipment.SM_GiftArticle;
    const isCompleted = shipment.SHPD_ScanQty === shipment.SHPD_ShipQty;
    return hasSpecialScheme && isCompleted;
  });

  if (completedSpecialShipments.length > 0) {
    // Create popup message based on the special values
    let message = "Special Scheme Alert!\n\n";
    
    completedSpecialShipments.forEach(shipment => {
      message += `Product: ${shipment.SHPD_ProductName}\n`;
      if (shipment.OSM_SM_Value) {
        message += `Scheme Value: ${shipment.OSM_SM_Value}\n`;
      }
      if (shipment.SM_GiftArticle) {
        message += `Gift Article: ${shipment.SM_GiftArticle}\n`;
      }
      message += "Scanning saved for this product.\n\n";
    });

    message += "Please proceed with special handling as per the scheme.";

    setSpecialPopupMessage(message);
    setIsSpecialPopupVisible(false);
    
    // Log the action
    logAction(`Special scheme products saved scanning: ${completedSpecialShipments.map(s => s.SHPD_ProductName).join(', ')}`);
  }
};

useEffect(() => {
  if (SelectedProduct && ShipmentsBySCP.length > 0) {
    const filteredShipmentsBySCP = ShipmentsBySCP.filter(
      (shipment) => shipment.SCPM_Name === SelectedProduct
    );

    const existingSCPIds = new Set(selectedShipmentsBySCP.map(item => `${item.SCPM_Name}-${item.SHPD_ProductCode}`));
    const newItems = filteredShipmentsBySCP.filter(item => 
      !existingSCPIds.has(`${item.SCPM_Name}-${item.SHPD_ProductCode}`)
    );
    
    if (newItems.length > 0) {
      setSelectedShipmentsBySCP((prevShipmentsBySCP) => [
        ...prevShipmentsBySCP,
        ...newItems,
      ]);

      const updatedData = [...selectedShipmentsBySCP, ...newItems];
      sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedData));
    }
  }
}, [SelectedProduct, ShipmentsBySCP]);

  //====================================================================

  //====================================================================
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [confirmationCallback, setConfirmationCallback] = useState(null);
  const [cancelCallback, setCancelCallback] = useState(null); // Cancel callback for "NO"
  const [message, setMessage] = useState("");
  const scannerInput = useRef("");

  const showPopup = (message, onConfirm, onCancel) => {
    setMessage(message);
    setConfirmationCallback(() => onConfirm);
    setCancelCallback(() => onCancel); // Assign cancel callback
    setPopupVisible(true);
  };

  const handlePopupConfirm = () => {
    if (confirmationCallback) confirmationCallback();
    setPopupVisible(false);
  };

  const handlePopupClose = () => {
    if (cancelCallback) cancelCallback(); // Run cancel callback if "NO" is clicked
    setPopupVisible(false);
  };

  //====================================================================

  const FetchVendorData = async (rsnValue , shipment, packSize) => {
    console.log('this is the Product ID which you have clicked :', SelectedProductID)
    console.log('This is the GTIN From Scanned Result :', ExtractedGTIN)
    try {
      if (!shipRandomrsn.getparentrsn) {
        console.error("shipRandomrsn.getparentrsn is undefined");
        return;
      } 
      
      if (SelectedShipmentID) {
        if (!ExtractedGTIN) {
          const RSNStatus = await fetch(
          `${config.API_URL}/RSN_Status_Outward_NonGTIN/${shipRandomrsn.getparentrsn}/${selectedScpId}/${SelectedProductID}`
        );
        if (RSNStatus.ok) {
          const data = await RSNStatus.json();
          console.log("Fetched Data:", data);
          if (data.IRS_Status === 6) {
            const RES = await fetch(
              `${config.API_URL}/ChildRSN_Lock_Outward/${data.IRS_RandomNo}`
            );
            if (RES.ok) {
              const data = await RES.json();
              console.log("Fetched Data:", data);
             
            } else {
              console.error("Error fetching the data");
            }
            const response = await fetch(
              `${config.API_URL}/ParentRSN_PackSize_Outward/${data.IRS_RandomNo}`
            );
            if (response.ok) {
              const data = await response.json();
              console.log("Fetched Data from ParentRSN_PackSize:", data);
              setFetchedData(data.PL_ProductCode);
              //  if (shipment.SHPD_ScanQty + packSize > shipment.SHPD_ShipQty) {
              if (data.IRS_ParentRandomNo) {
                // Show custom popup instead of window.confirm
                showPopup(
                  "Are you sure you want to disaggregate the Parent RSN ?",
                  async () => {
                    try {
                      const packSizeResponse = await fetch(
                        `${config.API_URL}/ParentRSN_Disaggregation_Outward/${data.IRS_RandomNo}`
                      );
                      if (packSizeResponse.ok) {
                        const packSizeData = await packSizeResponse.json();
                        console.log(
                          "Fetched Data from ParentRSN_Disaggregation:",
                          packSizeData
                        );
                        setFetchedData(packSizeData.IRS_PackSize);
                        setShipRandomrsn(packSizeData);
                        HandleAddRSNinBox(
                          packSizeData.IRS_PackSize,
                          packSizeData.PL_ProductCode
                        );
                        logAction(
                          ` All The Parent RSN of  ${data.IRS_RandomNo} of Shipment ID : ${SHPH_ShipmentID} disaggrigated successfully`
                        );
                      } else {
                        console.error("Error fetching IRS_PackSize data");
                      }
                    } catch (error) {
                      console.error("Error fetching IRS_PackSize data:", error);
                    }
                  },
                  async () => {
                    // Call when NO is clicked in popup
                    console.log("NO clicked: running IRS Status update");
                    try {
                      const response = await fetch(
                        `${config.API_URL}/Re_Update_Scanned_IRS_Status_Outward/${data.IRS_RandomNo}`,
                        { method: "PUT" }
                      );
                      if (response.ok) {
                        console.log(
                          `IRS_Status updated successfully for value '${data.IRS_RandomNo}'`
                        );
                      } else {
                        console.log(
                          `Failed to update IRS_Status for value '${data.IRS_RandomNo}'`
                        );
                      }
                    } catch (error) {
                      console.error("Error updating IRS_Status:", error);
                      console.log(
                        `Failed to update IRS_Status for value '${data.IRS_RandomNo}'`
                      );
                    }
                    setFetchedData("");
                    setScannedResultForSCP("");
                  }
                );
              } else {
                console.log(
                  "Setting IRS_PackSize directly:",
                  data.IRS_PackSize
                );
                setFetchedData(data.IRS_PackSize);
                setShipRandomrsn(data);
                HandleAddRSNinBox(data.IRS_PackSize, data.PL_ProductCode);
              }
              // }
            } else {
              console.error("Error fetching the data");
            }
          } 
          else if (data.IRS_Status === 22) {
            if (!isRSNScanned) {
              toast.warning("RSN already scanned");
              logAction(`RSN  ${data.IRS_RandomNo} already exist`);
              setScannedResultForSCP("");
              return;
            } else {
              console.log("RSN Scanned");
            }
          }
           else if (data.IRS_Status === 21) {
            if (!isRSNScanned) {
              toast.warning("Invalid RSN");
              logAction(`Invalid RSN ${data.IRS_RandomNo}`);
              return;
            } else {
              console.log("RSN Scanned");
            }
          } 
         } else if (RSNStatus.status === 404) {
          if (!isRSNScanned) {
            toast.warning("Invalid RSN");
            console.log("invalid RSN");
            setScannedResultForSCP("");
            console.error("Error fetching the RSN Status: No data found");
            return;
          } else {
            console.log("RSN Scanned");
          }
        } else {
          setScannedResultForSCP("");
          console.error("Error fetching the RSN Status");
        }
      } else { 
        const RSNStatus = await fetch(
          `${config.API_URL}/RSN_Status_Outward/${shipRandomrsn.getparentrsn}/${selectedScpId}/${SelectedProductID}/${ExtractedGTIN}`
        );
        if (RSNStatus.ok) {
          const data = await RSNStatus.json();
          console.log("Fetched Data:", data);
          if (data.IRS_Status === 6) {
            const RES = await fetch(
              `${config.API_URL}/ChildRSN_Lock_Outward/${data.IRS_RandomNo}`
            );
            if (RES.ok) {
              const data = await RES.json();
              console.log("Fetched Data:", data);
             
            } else {
              console.error("Error fetching the data");
            }
            const response = await fetch(
              `${config.API_URL}/ParentRSN_PackSize_Outward/${data.IRS_RandomNo}`
            );
            if (response.ok) {
              const data = await response.json();
              console.log("Fetched Data from ParentRSN_PackSize:", data);
              setFetchedData(data.PL_ProductCode);
              if (data.IRS_ParentRandomNo) {
                showPopup(
                  "Are you sure you want to disaggregate the Parent RSN ?",
                  async () => {
                    try {
                      const packSizeResponse = await fetch(
                        `${config.API_URL}/ParentRSN_Disaggregation_Outward/${data.IRS_RandomNo}`
                      );
                      if (packSizeResponse.ok) {
                        const packSizeData = await packSizeResponse.json();
                        console.log(
                          "Fetched Data from ParentRSN_Disaggregation:",
                          packSizeData
                        );
                        setFetchedData(packSizeData.IRS_PackSize);
                        setShipRandomrsn(packSizeData);
                        HandleAddRSNinBox(
                          packSizeData.IRS_PackSize,
                          packSizeData.PL_ProductCode
                        );
                        logAction(
                          ` All The Parent RSN of  ${data.IRS_RandomNo} of Shipment ID : ${SHPH_ShipmentID} disaggrigated successfully`
                        );
                      } else {
                        console.error("Error fetching IRS_PackSize data");
                      }
                    } catch (error) {
                      console.error("Error fetching IRS_PackSize data:", error);
                    }
                  },
                  async () => {
                    // Call when NO is clicked in popup
                    console.log("NO clicked: running IRS Status update");
                    try {
                      const response = await fetch(
                        `${config.API_URL}/Re_Update_Scanned_IRS_Status_Outward/${data.IRS_RandomNo}`,
                        { method: "PUT" }
                      );
                      if (response.ok) {
                        console.log(
                          `IRS_Status updated successfully for value '${data.IRS_RandomNo}'`
                        );
                      } else {
                        console.log(
                          `Failed to update IRS_Status for value '${data.IRS_RandomNo}'`
                        );
                      }
                    } catch (error) {
                      console.error("Error updating IRS_Status:", error);
                      console.log(
                        `Failed to update IRS_Status for value '${data.IRS_RandomNo}'`
                      );
                    }
                    setFetchedData("");
                    setScannedResultForSCP("");
                  }
                );
              } else {
                console.log(
                  "Setting IRS_PackSize directly:",
                  data.IRS_PackSize
                );
                setFetchedData(data.IRS_PackSize);
                setShipRandomrsn(data);
                HandleAddRSNinBox(data.IRS_PackSize, data.PL_ProductCode);
              }
              // }
            } else {
              console.error("Error fetching the data");
            }
          } 
          else if (data.IRS_Status === 22) {
            if (!isRSNScanned) {
              toast.warning("RSN already scanned");
              logAction(`RSN  ${data.IRS_RandomNo} already exist`);
              setScannedResultForSCP("");
              return;
            } else {
              console.log("RSN Scanned");
            }
          }
           else if (data.IRS_Status === 21) {
            if (!isRSNScanned) {
              toast.warning("Invalid RSN");
              logAction(`Invalid RSN ${data.IRS_RandomNo}`);
              return;
            } else {
              console.log("RSN Scanned");
            }
          } 
         } else if (RSNStatus.status === 404) {
          if (!isRSNScanned) {
            toast.warning("Invalid RSN");
            console.log("invalid RSN");
            setScannedResultForSCP("");
            console.error("Error fetching the RSN Status: No data found");
            return;
          } else {
            console.log("RSN Scanned");
          }
        } else {
          setScannedResultForSCP("");
          console.error("Error fetching the RSN Status");
        }
      }
      } else {
        toast.warning("Please Select a Product");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  //====================================================================

  const handleInputModeChange = (mode) => {
    setInputMode(mode);
    setManualInputEnabled(mode === "manual");
    setScannedResultForSCP(""); // Clear input field when switching mode
    logAction(`Manual RSN Entry selected`);
  };

  useEffect(() => {
    // Focus the input field whenever the inputMode changes
    if (inputRef.current) {
      inputRef.current.focus(); // Focus the input field
    }
    logAction(`Scanning RSN Entry selected`);
  }, [inputMode]);
  // const focusIntervalRef = useRef(null);
  
  const handleManualSubmit = () => {
    if (inputMode === "manual" && ScannedResultForSCP) {
      FetchVendorData(ScannedResultForSCP);
      if (
        ScannedResultForSCP &&
        !RSN.split("\n").includes(ScannedResultForSCP)
      ) {
        // Append the new value to the RSN list with a new line
        setRSN((prevRSN) => prevRSN + "\n");
        // Clear the input field after submission
        setScannedResultForSCP("");
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }, 0); // Ensure focus after state update
      }
    } else if (!ScannedResultForSCP || ScannedResultForSCP.trim() === "")  {
      toast.warning("Please Enter RSN");
    }
  };

const handleKeyDown = (e) => {
  if (!e.key.match(/^[\r\n\t]*$/)) {
    HandleScanChange(e); // Invoke your async handler
  }
};


  useEffect(() => {
    if (inputMode === "scan" && ScannedResultForSCP) {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
      debounceTimer.current = setTimeout(() => {
        if (
          ScannedResultForSCP &&
          !RSN.split("\n").includes(ScannedResultForSCP)
        ) {
          setRSN((prevRSN) => prevRSN + "\n");
          setScannedResultForSCP("");
        }
        FetchVendorData(ScannedResultForSCP);
        setScannedResultForSCP("");
      }, 500); // 1 second delay
      return () => {
        if (debounceTimer.current) {
          clearTimeout(debounceTimer.current);
        }
      };
    }
  }, [ScannedResultForSCP, shipRandomrsn.getparentrsn, inputMode]);

  const HandleInputChange = async (e) => {
    const scannedValue = e.target.value;
    
    setScannedResultForSCP(scannedValue);
    setShipRandomrsn({ getparentrsn: scannedValue });
    setFetchedData("");
  };

let scanTimeout;

const HandleScanChange = (e) => {
  const scannedValue = e.target.value.trim();
  if (scanTimeout) clearTimeout(scanTimeout);

  scanTimeout = setTimeout(() => {
    // Match RSN: (21|00) followed by 8–25 alphanumeric characters until (01|10|17) or end
    const rsnMatch = scannedValue.match(/\((21|00)\)([A-Z0-9]{8,25})(?=\(01\)|\(10\)|\(17\)|$)/i);

    // Match GTIN: (01) followed by 8–25 digits
    const gtinMatch = scannedValue.match(/\(01\)(\d{8,25})/);

    let extractedRSN = "";
    let extractedGTIN = null;

    if (rsnMatch && /^[A-Z0-9]{8,25}$/.test(rsnMatch[2])) {
      extractedRSN = rsnMatch[2];
    } else if (/^[A-Z0-9]{8,25}$/i.test(scannedValue)) {
      extractedRSN = scannedValue;
    }

    if (gtinMatch && /^\d{8,25}$/.test(gtinMatch[1])) {
      extractedGTIN = gtinMatch[1];
    }

    if (extractedRSN) {
      setScannedResultForSCP(extractedRSN);
      setShipRandomrsn({ getparentrsn: extractedRSN });
      setFetchedData("");
      console.log("Extracted RSN:", extractedRSN);
    } else {
      console.warn("Invalid or corrupted RSN");
      setScannedResultForSCP("");
    }

    if (extractedGTIN) {
      setExtractedGTIN(extractedGTIN);
      console.log("Extracted GTIN:", extractedGTIN);
    } else {
      setExtractedGTIN(null);
    }

    if (inputRef.current) inputRef.current.value = "";
  }, 50);
};

  const preventPaste = (e) => {
    e.preventDefault();
  };

const HandleAddRSNinBox = async (packSize, productCode) => {
  if (ScannedResultForSCP && !UniqueRSN.has(ScannedResultForSCP)) {
    let found = false;
    let updatedProductShipment = [...selectedShipmentsBySCP];

    if (SelectedShipmentID && SelectedProductID) {
      updatedProductShipment = updatedProductShipment.map((shipment) => {
        if (
          shipment.SHPD_ShipmentMID === SelectedShipmentID &&
          SelectedProductID === shipment.PL_ProductId
        ) {
          if (shipment.SHPD_ScanQty + packSize > shipment.SHPD_ShipQty) {
            toast.warning('Scanning limit reached');
            logAction(
              `Scan Quantity reached the limit please select another product`
            );
            return shipment;
          } else {
            found = true;
            return{
              ...shipment,
              SHPD_ScanQty: shipment.SHPD_ScanQty + packSize
            };
          }
        }
        return shipment;
      });
    } else {
      updatedProductShipment = updatedProductShipment.map((shipment) => {
        if (shipment.SHPD_ProductCode === productCode) {
          if (shipment.SHPD_ScanQty + packSize > shipment.SHPD_ShipQty) {
            toast.warning('Scanning limit reached');
            logAction(
              'Scan Quantity reached the limit please select another product'
            );
            return shipment;
          } else {
            found = true;
            return {
              ...shipment,
              SHPD_ScanQty: shipment.SHPD_ScanQty + packSize
            };
          }
        }
        return shipment;
      });
    }
    if (found) {
      setRSN((prevContent) => {
        const updated = prevContent +ScannedResultForSCP + "\n";
        const uniqueLines = [...new Set(updated.split("\n").filter((l) => l.trim() !==""))];
        return uniqueLines.join("\n");
      });
      setScannedResultForSCP("");
      setUniqueRSN((prevSerials) => new Set(prevSerials.add(ScannedResultForSCP)));
      logAction(
        `RSN : ${ScannedResultForSCP} is Scanned For Shipment ID : ${SHPH_ShipmentID}`
      );
      await fetchShipmentRSNLockForChild(SelectedShipmentID);
      await fetchShipmentRSNLockForParentRSN(SelectedShipmentID);
      try {
        const resp = await axios.get(
          `${config.API_URL}/RSNChainToMap/${ScannedResultForSCP}`
        );
        const newChain = resp.data.data;

        setRsnTree((prevTree) => {
          if (!prevTree || prevTree.length === 0) return [newChain];
          const exists = prevTree.some(
            (root) => root.IRS_RandomNo === newChain.IRS_RandomNo
          );
          return exists ? prevTree : [...prevTree, newChain];
        });
      } catch (err) {
        console.error("Faild To fetch RSN chain for new RSN :", err);
      }
      setSelectedShipmentsBySCP(updatedProductShipment);
      checkScanCompletionAndShowPopup(updatedProductShipment);
      // Update the session storage  with the updated shipents 
      sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedProductShipment));
    } else {
      setNotAddedValues((prevValues) => [...prevValues, ScannedResultForSCP]);
      await updateScannedIRSStatus();
    }
  } else if  (!ScannedResultForSCP) {
    await updateScannedIRSStatus();
  } else {
    await updateScannedIRSStatus();
  }
};



  const updateScannedIRSStatus = async () => {
    try {
      const response = await axios.put(
        `${config.API_URL}/Update_Bymistake_Scanned_RSN/${ScannedResultForSCP}`
      );
      if (response.status === 200) {
        console.log(
          `IRS_Status updated successfully for value '${ScannedResultForSCP}'`
        );
      } else {
        console.log(
          `Failed to update IRS_Status for value '${ScannedResultForSCP}'`
        );
      }
    } catch (error) {
      console.error("Error updating IRS_Status:", error);
      console.error(
        `Failed to update IRS_Status for value '${ScannedResultForSCP}'`
      );
    }
  };
  useEffect(() => {
    const updateIRSStatus = async () => {
      try {
        for (const value of notAddedValues) {
          const response = await axios.put(
            `${config.API_URL}/Re_Update_Scanned_IRS_Status_Outward/${value}`
          );
          if (response.status === 200) {
            console.log(
              `IRS_Status updated successfully for value '${ScannedResultForSCP}'`
            );
          } else {
            console.log(
              `Failed to update IRS_Status for value '${ScannedResultForSCP}'`
            );
          }
        }
        // Clear notAddedValues after updating IRS_Status for all values
        setNotAddedValues("");
      } catch (error) {
        console.error("Error updating IRS_Status:", error);
      }
    };
    // Call the updateIRSStatus function when notAddedValues changes
    if (notAddedValues.length > 0) {
      updateIRSStatus();
    }
  }, [notAddedValues]);

  const handleCheckBoxChange = (e, item) => {
    if (e.target.checked) {
      setCheckedItems((prevCheckedItems) =>
        new Set(prevCheckedItems).add(item)
      );
    } else {
      const newCheckedItems = new Set(CheckedItems);
      newCheckedItems.delete(item);
      setCheckedItems(newCheckedItems);
      sessionStorage.removeItem("RSN");
      sessionStorage.removeItem("CheckedItems");
    }
  };


const handleSelectAllChange = (e) => {
  if (e.target.checked) {
    let allItems = new Set();

    // 1. Include all RSNs from textarea
    RSN.split("\n")
      .filter((line) => line.trim() !== "")
      .forEach((line) => allItems.add(line));

    // 2. Include all root + children from rsnTree
    const collectAllNodes = (node) => {
      allItems.add(node.IRS_RandomNo);
      if (node.children && node.children.length > 0) {
        node.children.forEach(collectAllNodes);
      }
    };
    if (rsnTree) {
      rsnTree.forEach(collectAllNodes);
    }
    setCheckedItems(allItems);
  } else {
    setCheckedItems(new Set());
  }
};


const handleSCPChange = async (selectedOption) => {
  const selectedProduct = selectedOption?.value;
  setSelectedProduct(selectedProduct);
  handleAutoSCPSelection(selectedProduct);
}
const removeSelectedItemsAndUpdateStatus = async () => {
  console.log("Before-",selectedShipmentsBySCP)
  try {
    const selectedItems = Array.from(CheckedItems);

    // Check if there are any selected items
    if (selectedItems.length === 0) {
      toast.warn("Please select a minimum one serial number");
      logAction("Please select a minimum one serial number");
      return;
    }

    // --- API call to update status in backend ---
    const response = await axios.put(
      `${config.API_URL}/Update_Removed_RSN_Status_Outward`,
      {
        IRS_RandomNos: selectedItems,
      }
    );

    if (response.status === 200) {
      console.log("IRS_Status updated successfully for the selected items");
      logAction(
        `IRS_Status updated successfully for the selected items ${selectedItems}`
      );

      // --- Update shipments ---
      const { packSizes } = response.data;
      const totalPackSizeByProduct = packSizes.reduce((acc, packSize) => {
        const { PL_ProductCode, IRS_PackSize, SHPD_SCPCode } = packSize;
        const key = `${PL_ProductCode}-${SHPD_SCPCode}`;
        acc[key] = (acc[key] || 0) + IRS_PackSize;
        return acc;
      }, {});

      const updatedShipments = selectedShipmentsBySCP.map((shipment) => {
        const key = `${shipment.SHPD_ProductCode}-${shipment.SHPD_SCPCode}`;
        const totalPackSize = totalPackSizeByProduct[key] || 0;
        shipment.SHPD_ScanQty = Math.max(
          0,
          shipment.SHPD_ScanQty - totalPackSize
        );
        return shipment;
      });

      setSelectedShipmentsBySCP(updatedShipments);
      sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedShipments));
      // --- Update child RSN status in backend ---
      await axios.post(`${config.API_URL}/ChildRSN_Status_OutwardScan`, {
        IRS_RandomNos: selectedItems,
      });

      // --- Update RSN textarea ---
      const remainingRSN = RSN.split("\n")
        .map((line) => line.trim())
        .filter((line) => !selectedItems.includes(line)) // FIX: use selectedItems
        .join("\n");

      setRSN(remainingRSN.trim());

      // --- Update rsnTree (box UI) ---
      setRsnTree((prevTree) => {
        if (!prevTree) return prevTree;

        // Recursive child remover
        const removeNodes = (node) => {
          if (!node.children) return node;
          return {
            ...node,
            children: node.children
              .filter((child) => !selectedItems.includes(child.IRS_RandomNo))
              .map((child) => removeNodes(child)),
          };
        };

        // Remove roots + clean children
        return prevTree
          .filter((root) => !selectedItems.includes(root.IRS_RandomNo))
          .map((root) => removeNodes(root));
      });

      // --- Clear checkboxes ---
      setCheckedItems(new Set());

      // --- Update UniqueRSN ---
      selectedItems.forEach((item) => {
        if (UniqueRSN.has(item)) {
          UniqueRSN.delete(item);
        }
      });

      toast.success(`Selected RSN removed successfully`);

      // --- Reset Select All checkbox ---
      const selectAllCheckbox = document.getElementById("selectAll");
      if (selectAllCheckbox) {
        selectAllCheckbox.checked = false;
      }

      // --- Trigger UI refresh for input ---
      setRefreshTrigger((prev) => prev + 1);
      document.getElementById("RSNInput")?.dispatchEvent(new Event("input"));
       setTimeout(() => {
        // window.location.reload();
      }, 1000);
    } else {
      console.error("Failed to update IRS_Status for the selected items");
    }
  } catch (error) {
    console.error("Error updating IRS_Status:", error);
  }
  console.log("After-",selectedShipmentsBySCP)
};

  const updateScanQuantity = async (shipment) => {
    const {
      SHPD_ShipmentID,
      SHPD_ProductCode,
      SHPD_ScanQty,
      SHPH_ShipmentCode,
    } = shipment;

    try {
      // Step 1: Update scan quantity
      const updateScanResponse = await axios.put(
        `${config.API_URL}/Update_Scanqty_Outward`,
        {
          SHPD_ShipmentID,
          SHPD_ProductCode,
        }
      );

      if (updateScanResponse.status !== 200) {
        console.log(
          `Failed to update scan quantity for Shipment ID ${SHPD_ProductCode}`
        );
        logAction(
          `Failed to update scan quantity for Shipment ID ${SHPD_ProductCode}`
        );
        return;
      }
      //======================================
      //======================================
      console.log("Function is called");
      const details = {
        AUTR_Message: `Shipment ${SHPH_ShipmentCode} Completed`,
        AUTR_AuditType: "insert",
        AUTR_NewValue: "",
        AUTR_OldValue: "-",
      };
      let id = await audittrailpost(details);

      const logAuditTrail = (message, id, newValue, oldValue) => {
        const details = {
          AUTRN_ParamererName: message,
          AUTRN_ID: id,
          AUTRN_NewValue: newValue,
          AUTRN_OldValue: oldValue,
        };
        audittransection(details);
      };

      logAuditTrail("Shipment ", id, SHPH_ShipmentCode, "-");
      console.log("Function is called ");
      //========================================
      //========================================
      const { SHPH_FromSCPCode, PL_ProductId } =
        updateScanResponse.data.updatedData;

      // Step 2: Fetch inventory data
      const inventoryResponse = await axios.get(
        `${config.API_URL}/Inventory_Outward/${SHPH_FromSCPCode}/${PL_ProductId}`
      );

      if (inventoryResponse.status !== 200) {
        console.log(
          `Failed to fetch inventory data for SCPID ${SHPH_FromSCPCode} and Product ID ${PL_ProductId}`
        );
        return;
      }

      const inventoryData = inventoryResponse.data.inventorydata[0];
      const { inv_blockqty, inv_availableqty } = inventoryData;

      const updatedBlockQty = inv_blockqty - SHPD_ScanQty;
      const updatedAvailableQty = inv_availableqty - SHPD_ScanQty;

      // Step 4: Update inventory data
      const updateInventoryResponse = await axios.put(
        `${config.API_URL}/Inventory_Outward/${SHPH_FromSCPCode}/${PL_ProductId}`,
        {
          inv_blockqty: updatedBlockQty,
          inv_availableqty: updatedAvailableQty,
        }
      );

      if (updateInventoryResponse.status !== 200) {
        
        console.log(
          `Failed to update inventory for SCPID ${SHPH_FromSCPCode} and Product ID ${PL_ProductId}`
        );
        return;
      }
      // Step 5: Display success message
      // toast.success(`Shipment : ${SHPH_ShipmentCode} saved successfully`);
      toast.success(`Shipment : ${SHPH_ShipmentCode} saved successfully.`, {
        toastId: `shipment-${SHPD_ShipmentID}`,
      });

      logAction(`Shipment : ${SHPH_ShipmentCode} saved successfully.`);

      setTimeout(() => {
        navigate("/ShipOutScanPendingList");
      }, 2000);
    } catch (error) {
      console.error(
        `Error processing request for Shipment ID ${SHPD_ShipmentID}:`,
        error
      );
      toast.error(
        `Failed to process request for Shipment  ${SHPH_ShipmentCode}`
      );
      logAction(`Failed to process request for Shipment  ${SHPH_ShipmentCode}`);
    }
  };

  // ==================== Used For Shipment Lock =========================
  const fetchShipmentRSNLockForChild = async (SelectedShipmentID) => {
    try {
      const response = await axios.get(
        `${config.API_URL}/ShipmentData_For_RSN_Outward/${SelectedShipmentID}/${SHPH_ShipmentID}`
      );
      const shipmentData = response.data.ShipmentForRSN;
      console.log("Shipment Data:", shipmentData);
      for (const item of shipmentData) {
        await axios.put(
          `${config.API_URL}/ChildRSNLockToShipMentID_Outward/${shipRandomrsn.getparentrsn}`,
          {
            IRS_ShipmentID: item.IRS_ShipmentID,
            IRS_ToSCP: item.IRS_ToSCP,
            IRS_PhysicalLocation: item.IRS_PhysicalLocation,
          }
        );
      }
    } catch (error) {
      console.error("Error fetching shipment data:", error);
    }
  };

  const fetchShipmentRSNLockForParentRSN = async (SelectedShipmentID) => {
    try {
      const response = await axios.get(
        `${config.API_URL}/ShipmentData_For_RSN_Outward/${SelectedShipmentID}/${SHPH_ShipmentID}`
      );
      const shipmentData = response.data.ShipmentForRSN;
      console.log("Shipment Data:", shipmentData);

      for (const item of shipmentData) {
        await axios.put(
          `${config.API_URL}/ParentRSNLockToShipMentID_Outward/${shipRandomrsn.getparentrsn}`,
          {
            IRS_ShipmentID: item.IRS_ShipmentID,
            IRS_ToSCP: item.IRS_ToSCP,
            IRS_PhysicalLocation: item.IRS_PhysicalLocation,
          }
        );
        const packSizeResponse = await axios.get(
          `${config.API_URL}/ParentRSN_Lock_Update_Outward/${shipRandomrsn.getparentrsn}/${item.IRS_ShipmentID}/${item.IRS_ToSCP}`
        );

        if (packSizeResponse.status === 200) {
          const packSizeData = packSizeResponse.data;
          console.log(
            "Fetched Data from ParentRSN_Disaggregation:",
            packSizeData
          );
          //=======================//===================//===============//
          const parentRSNResponse = await fetch(
            `${config.API_URL}/Disaggrigated_RSN_History_Outward`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                IRS_RandomNo: shipRandomrsn.getparentrsn,
              }),
            }
          );
          const parentRSNData = await parentRSNResponse.json();
          if (parentRSNResponse.ok && parentRSNData.IRS_ParentRandomNo) {
            const parentRandomNo = parentRSNData.IRS_ParentRandomNo;
            logAction(
              `The Parent RSN : ${parentRandomNo.join(", ")} of RSN ${
                shipRandomrsn.getparentrsn
              } of Shipment ID : ${SHPH_ShipmentID} Disaggregated Successfully`
            );
          }
          //=======================//===================//===============//

          console.log(
            "ShipmentID",
            item.IRS_ShipmentID,
            "SHPD SCP ID",
            item.IRS_ToSCP
          );
        } else {
          console.error("Error fetching IRS_PackSize data");
        }
      }
    } catch (error) {
      console.error("Error fetching shipment data:", error);
    }
  };


  
  const [saveCallCount, setSaveCallCount] = useState(0); // Initialize call count state
  
  const handleSave = async (e) => {
  e.preventDefault();
  
  // Check if the function has already been called
  if (saveCallCount > 0) {
    console.log("handleSave function already called, ignoring subsequent calls.");
    return; // Disable further execution
  }
  
  // Increase the call count
  setSaveCallCount((prevCount) => prevCount + 1);
  
  try {
    // First update scan quantities
    for (const shipment of selectedShipmentsBySCP) {
      await updateScanQuantity(shipment);
    }
    checkScanCompletionAndShowPopup(selectedShipmentsBySCP);
    // Then insert IRS info
    await callInsertIRSInfoAPI();
    
    console.log("Shipment Outward Scanning Completed");
    
    // Clear session storage
    sessionStorage.removeItem('shipmentTableData');
    setIsSaveButtonDisabled(true);
  } catch (error) {
    console.error("Error updating scan quantities:", error);
    toast.error("Failed to complete the shipment");
    
    // Reset the call count on error to allow retry
    setSaveCallCount(0);
  }
};
  //==========================================================

  const callInsertIRSInfoAPI = async () => {
  // Collect RSNs from textarea
  const textareaRSNs = Array.from(
    new Set(RSN.split("\n").filter((line) => line.trim() !== ""))
  );
  
  // Collect RSNs from rsnTree (including all children)
  const treeRSNs = [];
  const collectAllNodes = (node) => {
    treeRSNs.push(node.IRS_RandomNo);
    if (node.children && node.children.length > 0) {
      node.children.forEach(collectAllNodes);
    }
  };
  
  if (rsnTree) {
    rsnTree.forEach(collectAllNodes);
  }
  
  // Combine and deduplicate all RSNs
  const allRSNValues = Array.from(new Set([...textareaRSNs, ...treeRSNs]));
  
  if (allRSNValues.length === 0) {
    console.log("No RSNs available to insert.");
    return;
  }
  
  console.log("Calling IRS info API with RSNs:", allRSNValues);
  
  try {
    const response = await axios.post(
      `${config.API_URL}/All_RSN_History_Insertion_Outward`,
      {
        IRS_RandomNos: allRSNValues, // Send all RSNs to the API
      }
    );
    
    if (response.status === 200) {
      console.log(
        "Data successfully inserted into rsnhistoryinfo:",
        response.data
      );

      const RackSpace = await axios.get(
        `${config.API_URL}/RackSpace_Shipment_Outward/${SHPH_ShipmentID}/${selectedScpId}`
      );
      
      if (RackSpace.status === 200) {
        console.log(`Logical Location updated successfully `);
      } else {
        console.log(`Failed to update Logical Location `);
      }

      logAction("IRS info inserted successfully");
    } else {
      console.log("Failed to insert IRS info:", response);
    }
  } catch (error) {
    console.error("Error inserting IRS info:", error);
    logAction("Failed to insert IRS info");
  }
};
  //==========================================================
 
  const isSaveButtonVisible = () => {
    return selectedShipmentsBySCP.every(
      (shipment) => shipment.SHPD_ShipQty === shipment.SHPD_ScanQty
    );
  };
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };
const handleRowClick = (shipment) => {
  // Save clicked shipment + product info in state
  setSelectedShipmentID(shipment.SHPD_ShipmentMID);
  setSelectedProductID(shipment.PL_ProductId);

  console.log("Row clicked →", {
    shipmentId: shipment.SHPD_ShipmentMID,
    productId: shipment.PL_ProductId,
    productCode: shipment.SHPD_ProductCode,
    productName: shipment.SHPD_ProductName,
  });

};

  return (
    <>
      {/* <Sto /> */}
      <ToastContainer
        style={{
          marginTop: "73px",
          fontSize: "14px",
          width: "40%",
        }}
      />
      <div className="main_container">
        <h4 className="formHeading"> Vendor wise scanning </h4>
        <div className="">
          <div className="row">
            <div className="col-md-4">
              <div className="mb-3">
                <label className="form-label">SCP Name</label>
                <div className="select-container">
                
                <Select
  options={SCPNames}
  value={SCPNames.find(
    (option) => option.value === SelectedProduct
  )}
  onChange={handleSCPChange}
  placeholder="Select SCP Name"
  className="routing_select-box"
  isSearchable
  isOptionDisabled={(option) => option.isDisabled}
  styles={{
    option: (base, state) => ({
      ...base,
      color: state.isDisabled ? "#999" : base.color,
      backgroundColor: state.isDisabled
        ? "#fff"
        : base.backgroundColor,
      cursor: state.isDisabled ? "not-allowed" : "default",
    }),
  }}
  onMenuOpen={() => handleSelectOpen('scpName')}
  onMenuClose={handleSelectClose}
/>
                <div className='icon-container'>
                    {isSelectOpen === 'scpName' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                </div>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="mb-3">
                <div className="d-flex align-items-center">
                  <label
                    className="form-label"
                    style={{ marginBottom: "-5px" }}
                  >
                    RSN
                  </label>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      marginRight: "-25px",
                    }}
                  >
                    <input
                      type="radio"
                      name="inputMode"
                      value="manual"
                      checked={inputMode === "manual"}
                      onChange={() => handleInputModeChange("manual")}
                      style={{
                        accentColor: "black",
                        marginRight: "-25px",
                      }}
                    />
                    <label style={{ margin: "0" }}>Manual</label>
                  </div>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      marginRight: "-25px",
                    }}
                  >
                    <input
                      type="radio"
                      name="inputMode"
                      value="scan"
                      checked={inputMode === "scan"}
                      onChange={() => handleInputModeChange("scan")}
                      style={{
                        accentColor: "black",
                        marginRight: "-25px",
                      }}
                    />
                    <label style={{ margin: "0" }}>Scan</label>
                  </div>
                </div>

                {/* Manual Input Field */}
                {inputMode === "manual" && (
                  <div className="d-flex align-items-center mt-2">
                    <div
                      className="input-group"
                      style={{ flexGrow: 1, marginRight: "10px" }}
                    >
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Enter RSN"
                        ref={inputRef} // Use the inputRef to reference this input element
                        value={ScannedResultForSCP || ""}
                        onChange={HandleInputChange}
                        disabled={!SelectedProduct && !manualInputEnabled} // Disabled until product is selected or manual input is enabled
                        style={{ width: "100%" }}
                      />
                    </div>
                    <button
                      className="btn btn-dark"
                      onClick={handleManualSubmit}
                    >
                      SUBMIT
                    </button>
                  </div>
                )}

                {/* Scan Input Field */}
                {inputMode === "scan" && (
                  <div className="d-flex align-items-center mt-2">
                    <div
                      className="input-group"
                      style={{ flexGrow: 1, marginRight: "10px" }}
                    >
                      
                   <input
                     type="text"
                     className="form-input"
                     placeholder="Scan RSN"
                     ref={inputRef}
                     defaultValue=""
                     onChange={HandleScanChange}
                     onPaste={preventPaste}
                     onKeyDown={handleKeyDown}
                     disabled={!SelectedProduct}
                     style={{ width: "100%" }}
                   />
                    </div>
                  </div>
                )}
              </div>
            </div>
    
          </div>
        </div>
        {isGift?.SCPM_Name && isGift.SCPM_Name.length > 0 ? (
        isGift.SCPM_Name.some(
          (item) => item.SM_GiftArticle && item.OSM_SM_Value
        ) ? (
          isGift.SCPM_Name.map((item) =>
            item.SM_GiftArticle && item.OSM_SM_Value ? (
              <p key={item.SCPM_ID} style={{ color: "green", fontWeight: "bold" }}>
                Hope you have packed {item.OSM_SM_Value} × {item.SM_GiftArticle} for SCP{" "}
                {item.SCPM_Name} {/*({item.SCPM_ID})*/}
              </p>
            ) : null
          )
        ) : (
          <p></p>
        )
      ) : (
        <p>Loading...</p>
      )}
        <div className="row mt-3">
          <div className="col-md-9">
            <div className="tableScanContainer">
              <table className="scantableClass">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th className="nav-tabs">SCP Name</th>
                    <th className="nav-tabs">Product Name </th>
                    <th className="nav-tabs">Product Code </th>
                    <th className="nav-tabs">Available Qty</th>
                    <th className="nav-tabs">Scanned Qty</th>
                    <th className="nav-tabs">Shipment Qty</th>
                  </tr>
                </thead>
             
                <tbody>
                  {selectedShipmentsBySCP.map((shipment, index) => {
                    const isSelected = SelectedShipmentID === shipment.SHPD_ShipmentMID;
                    const isCompleted = shipment.SHPD_ShipQty === shipment.SHPD_ScanQty;
                    
                    return (
                      <tr
                        key={shipment.SHPD_ShipmentMID}
                        onClick={() => handleRowClick(shipment)}
                        className={
                          isSelected 
                            ? isCompleted ? "highlight" : "auto-highlight" 
                            : ""
                        }
                        style={{
                          cursor: isCompleted ? 'not-allowed' : 'pointer',
                          opacity: isCompleted ? 0.6 : 1
                        }}
                      >
                        <td>{index + 1}</td>
                        <td>{shipment.SCPM_Name}</td>
                        <td>{shipment.SHPD_ProductName}</td>
                        <td>{shipment.SHPD_ProductCode}</td>
                        <td>{shipment.inv_availableqty}</td>
                        <td>{shipment.SHPD_ScanQty}</td>
                        <td>{shipment.SHPD_ShipQty}</td>
                      </tr>
                    );
                  })}
               </tbody>
              </table>
              {SelectedProduct && selectedShipmentsBySCP.length === 0 && (
                <div>
                  No ShipmentsBySCP available for the selected SCPM_Name
                </div>
              )}
            </div>
          </div>

          <div className="col-md-3">
            <div className="scanContainer">
               <p className="scannedHeading">Scanned RSN List</p>
               <div>
                 <input
                   className="form-check-input"
                   type="checkbox"
                   id="selectAll"
                   onChange={handleSelectAllChange}
                 />
                 <label className="form-check-label" htmlFor="selectAll">
                   Select All
                 </label>
               </div>
               {[...new Set(RSN.split("\n").filter((line) => line.trim() !== ""))].map(
                 (line, index) => (
                   <div key={index}>
                     {/* <label>{line}</label> */}
                   </div>
                 )
               )}
               {/* Deduplicated RSN tree */}
               {rsnTree &&
                 rsnTree.map((rootNode) =>
                   renderRSNNode(rootNode, 0, rootNode.isRoot)
                 )}
             </div>

          </div>
          <div className="button-container mt-2">
            <button
              onClick={removeSelectedItemsAndUpdateStatus}
              className="scan_btn"
            >
              REMOVE SELECTED
            </button>
          </div>
        </div>
      </div>
      <div className="button-container">
        {isSaveButtonVisible() && (
          <button
            className="save_btn"
            onClick={handleSave}
            disabled={
              isSaveButtonDisabled || (!SelectedProduct && !manualInputEnabled)
            }
          >
            SAVE
          </button>
        )}

        {isPopupVisible && (
          <div className="popup-box">
            <div className="popup-content-Suspend">
              <h5 className="Suspend-Popup-Heading">:: User Confirmation ::</h5>
              <p className="Suspend-Popup-Text">{message}</p>
              <div>
                <button
                  className="button-Confirm-Popup"
                  onClick={handlePopupConfirm}
                >
                  YES
                </button>
                <button
                  className="button-Close-Popup"
                  onClick={handlePopupClose}
                >
                  NO
                </button>
              </div>
            </div>
          </div>
        )}
      {isSpecialPopupVisible && (
  <div className="popup-overlay">
    <div className="popup-content special-scheme-popup">
      <div className="popup-header">
        <h5>🎁 Special Scheme Alert</h5>
      </div>
      <div className="popup-body">
        <p style={{ 
          whiteSpace: 'pre-line', 
          textAlign: 'left',
          fontSize: '14px',
          lineHeight: '1.5'
        }}>
          {specialPopupMessage}
        </p>
      </div>
      <div className="popup-footer">
        <button
          className="btn btn-primary"
          onClick={() => setIsSpecialPopupVisible(false)}
          style={{ padding: '8px 20px' }}
        >
          Understood
        </button>
      </div>
    </div>
  </div>
)}
        <Link 
        to={`/ShipOutScanPendingList`} 
        className="back_btn" 
        type="button"
        onClick={() => sessionStorage.removeItem('shipmentTableData')}
        >
          LIST
        </Link>
      </div>
    </>
  );
}

export default ShipOutScanByVendor;












































// import React, { useState, useEffect, useContext, useRef } from "react";
// import { Link, useParams, useNavigate } from "react-router-dom";
// import axios from "axios";
// import "../ShipmentSelectScanType.css";
// import { ToastContainer, toast } from "react-toastify";
// import "jspdf-autotable";

// import { UserContext } from "../../common/UserContext";
// import config from "../../../envconfig";
// import Select from "react-select";
// import { IoCaretDownOutline, IoCaretUpOutline } from "react-icons/io5";

// function ShipOutScanByVendor() {
//   const {
//     UM_CompanyGrpID,
//     selectedScpId,
//     UM_CompanyID,
//     UM_UserId,
//     UM_UserCode,
//   } = useContext(UserContext);

//   const { SHPH_ShipmentID } = useParams();
//   const navigate = useNavigate();
//   const [RSN, setRSN] = useState("");
//   const [UniqueRSN, setUniqueRSN] = useState(new Set());
//   const [SelectedShipmentID, setSelectedShipmentID] = useState(null);
//   const [SelectedProductID, setSelectedProductID] = useState(null);
//   const [CheckedItems, setCheckedItems] = useState(new Set());
//   const [SCPNames, setSCPNames] = useState([]);
//   const [ShipmentsBySCP, setShipmentsBySCP] = useState([]);
//   const [SelectedProduct, setSelectedProduct] = useState("");
//   const [ExtractedGTIN, setExtractedGTIN] = useState(null);
//   const [selectedShipmentsBySCP, setSelectedShipmentsBySCP] = useState([]);
//   const [ScannedResultForSCP, setScannedResultForSCP] = useState(null);
//   const [shipRandomrsn, setShipRandomrsn] = useState({ getparentrsn: "" });
//   const [fetchedData, setFetchedData] = useState("");
//   const [notAddedValues, setNotAddedValues] = useState([]);
//   const [isRSNScanned, setIsRSNScanned] = useState(false);
//   const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false); // Step 1: Track button click state
//   const [manualInputEnabled, setManualInputEnabled] = useState(false);
//   const [isGift,setisGift] = useState();
//   console.log("isgift",isGift)
//   const [inputMode, setInputMode] = useState("scan"); // "scan" or "manual"
//   const inputRef = useRef(null); // Add useRef to reference the input element
//   const debounceTimer = useRef(null);
//   // const [ClickedRowProductID, setClickedRowProductID]
//   //=======================================  
//   //================================================================================
//   // Scheme Related
//   const [isSpecialPopupVisible, setIsSpecialPopupVisible] = useState(false);
//   const [specialPopupMessage, setSpecialPopupMessage] = useState("");
//   const [shipmentSpecialData, setShipmentSpecialData] = useState({});
//   //================================================================================

// const [loading, setLoading] = useState(false);
// const [refreshTrigger, setRefreshTrigger] = useState(0);


// const [rsnTree, setRsnTree] = useState(null);
// const [expandedNodes, setExpandedNodes] = useState(new Set());

// const renderRSNNode = (node, level = 0, isRoot = false, insideBox = false) => {
//   const hasChildren = node.children && node.children.length > 0;
//   const isExpanded = expandedNodes.has(node.IRS_RandomNo);

//   return (
//     <div key={node.IRS_RandomNo} style={{ marginLeft: level * 20 }}>
//       {/* Root Node */}
//       {isRoot ? (
//         <>
//           <input
//             className="form-check-input"
//             type="checkbox"
//             checked={CheckedItems.has(node.IRS_RandomNo)}
//             onChange={(e) => handleCheckBoxChange(e, node.IRS_RandomNo)}
//             value={node.IRS_RandomNo}
//             id={`check-${node.IRS_RandomNo}`}
//           />
//           <label
//             className="form-check-label"
//             htmlFor={`check-${node.IRS_RandomNo}`}
//             style={{ color: "#465a64", marginLeft: "6px" }}
//           >
//             {node.IRS_RandomNo}
//           </label>

//           {/* Expand/Collapse button for root */}
//           {hasChildren && (
//             <button
//               type="button"
//               className="btn btn-link btn-sm"
//               style={{ fontSize: "12px", padding: "2px 6px", marginLeft: "6px" }}
//               onClick={() => {
//                 const newExpanded = new Set(expandedNodes);
//                 if (isExpanded) newExpanded.delete(node.IRS_RandomNo);
//                 else newExpanded.add(node.IRS_RandomNo);
//                 setExpandedNodes(newExpanded);
//               }}
//             >
//               {isExpanded ? "➖" : "➕"}
//             </button>
//           )}
//         </>
//       ) : (
//         <div style={{ display: "flex", alignItems: "center" }}>
//           {/* Always reserve space for expand/collapse if inside box */}
//           {insideBox && (
//             <div style={{ width: "18px", textAlign: "center" }}>
//               {hasChildren ? (
//                 <button
//                   type="button"
//                   className="btn btn-link btn-sm"
//                   style={{
//                     fontSize: "12px",
//                     padding: "1px 3px",
//                     lineHeight: "1",
//                   }}
//                   onClick={() => {
//                     const newExpanded = new Set(expandedNodes);
//                     if (isExpanded) newExpanded.delete(node.IRS_RandomNo);
//                     else newExpanded.add(node.IRS_RandomNo);
//                     setExpandedNodes(newExpanded);
//                   }}
//                 >
//                   {isExpanded ? "➖" : "➕"}
//                 </button>
//               ) : (
//                 <span style={{ display: "inline-block", width: "12px" }} />
//               )}
//             </div>
//           )}

//           {/* Label */}
//           <span style={{ color: "#465a64", marginLeft: "6px" }}>
//             {node.IRS_RandomNo}
//           </span>
//         </div>
//       )}

//       {/* Children */}
//       {hasChildren && isExpanded && (
//         <div
//           style={{
//             marginTop: 6,
//             border: isRoot ? "1px solid #ccc" : "none",
//             borderRadius: isRoot ? "6px" : "0",
//             padding: isRoot ? "10px" : "0",
//           }}
//         >
//           {node.children.map((child) =>
//             renderRSNNode(child, level + 1, child.isRoot, true) // insideBox = true
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

  
//   const logAction = async (action, isError = false) => {
//     try { // API_URL
//       const response = await fetch(`${config.API_URL}/api/log`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           module: `Shipment Outward Scanning By Vendor :`,
//           action,
//           userCode: UM_UserCode,
//           isError,
//         }),
//       });
//       if (!response.ok) {
//         throw new Error("Failed to log action");
//       }
//     } catch (error) {
//       console.error("Error logging action:", error);
//     }
//   };
//   //====================================================================

//   //============================= Audit Trail ==========================
//   const audittransection = async (data) => {
//     const formData = {
//       AUTRN_ID: data.AUTRN_ID,
//       AUTRN_OldValue: data.AUTR_NewValue ?? null,
//       AUTRN_NewValue: data.AUTRN_NewValue,
//       AUTRN_ParamererName: data.AUTRN_ParamererName,
//     };
//     try {
//       const response = await axios.post(
//         `${config.API_URL}/api/audittransaction`,
//         formData
//       );
//       // alert('Data inserted successfully');
//     } catch (error) {
//       if (error.response) {
//         console.error("Server responded with an error:", error.response.data);
//       } else if (error.request) {
//         console.error("No response received:", error.request);
//       } else {
//         console.error("Error setting up the request:", error.message);
//       }
//     }
//   };

//   const audittrailpost = async (details) => {
//     const getCurrentTimestamp = () => {
//       const now = new Date();
//       const year = now.getFullYear();
//       const month = String(now.getMonth() + 1).padStart(2, "0"); // months are zero-indexed
//       const day = String(now.getDate()).padStart(2, "0");
//       const hours = String(now.getHours()).padStart(2, "0");
//       const minutes = String(now.getMinutes()).padStart(2, "0");
//       const seconds = String(now.getSeconds()).padStart(2, "0");
//       return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//     };

//     const currentTimestamp = getCurrentTimestamp();
//     const AUTR_OldValue = details?.AUTR_OldValue ?? null;
//     const AUTR_NewValue = details?.AUTR_NewValue ?? null;
//     const AUTR_Message = details.AUTR_Message;
//     const AUTR_AuditType = details.AUTR_AuditType;
//     if (
//       UM_CompanyID === null ||
//       UM_CompanyID === "null" ||
//       UM_CompanyGrpID === null ||
//       UM_CompanyGrpID === "null" ||
//       selectedScpId === null ||
//       selectedScpId === "null"
//     ) {
//       console.log("null--------");
//       const data = {
//         AUTR_ScreenName: "Shipment Outward Scanning",
//         AUTR_OldValue: AUTR_OldValue,
//         AUTR_NewValue: AUTR_NewValue,
//         AUTR_Message: AUTR_Message,
//         AUTR_UserID: UM_UserId,
//         AUTR_UserName: UM_UserCode,
//         AUTR_TimeStamp: currentTimestamp,
//         AUTR_AuditType: AUTR_AuditType,
//         AUTR_SCPID: null,
//         AUTR_CompanyGrpId: null,
//         AUTR_CompanyID: null,
//         AUTR_CreatedBy: UM_UserId,
//         AUTR_CreatedDateTime: currentTimestamp,
//       };
//       console.log(data);
//       try {
//         const response = await axios.post(
//           `${config.API_URL}/api/audittrail`,
//           data
//         );
//         console.log("Success:", response.data);
//         return response.data;
//       } catch (error) {
//         console.error("Error:", error);
//       }
//     } else {
//       console.log("null--------");
//       const data = {
//         AUTR_ScreenName: "Shipment Outward Scanning",
//         AUTR_OldValue: AUTR_OldValue,
//         AUTR_NewValue: AUTR_NewValue,
//         AUTR_Message: AUTR_Message,
//         AUTR_UserID: UM_UserId,
//         AUTR_UserName: UM_UserCode,
//         AUTR_TimeStamp: currentTimestamp,
//         AUTR_AuditType: AUTR_AuditType,
//         AUTR_SCPID: selectedScpId,
//         AUTR_CompanyGrpId: UM_CompanyID,
//         AUTR_CompanyID: UM_CompanyID,
//         AUTR_CreatedBy: UM_UserId,
//         AUTR_CreatedDateTime: currentTimestamp,
//       };
//       console.log(data);
//       try {
//         const response = await axios.post(
//           `${config.API_URL}/api/audittrail`,
//           data
//         );
//         console.log("Success:", response.data);
//         return response.data;
//       } catch (error) {
//         console.error("Error:", error);
//       }
//     }
//   };
//   //====================================================================


//   useEffect(() => {
//     const fetchSCPNames = async () => {
//       try {
//         const response = await axios.get(
//           `${config.API_URL}/SCP_Code_vendor/${SHPH_ShipmentID}`
//         );
//         const data = response.data;
//         console.log("ShipmentData-",data)
//         setisGift(data)
//         if (response.status === 200) {
//           const uniqueSCPNames = Array.from(
//             new Set(
//               data.SCPM_Name.map((scpName) => ({
//                 value: scpName.SCPM_Name,
//                 label: scpName.SCPM_Name,
//               }))
//             )
//           );
//           setSCPNames(uniqueSCPNames);
//         } else {
//           console.error("Error fetching SCP Names:", data.error);
//           toast.error("Failed to fetch SCP Names");
//         }
//       } catch (error) {
//         console.error("Failed to fetch SCP Names:", error);
//         toast.error("Failed to fetch SCP Names");
//       }
//     };

//     fetchSCPNames();
//   }, [SHPH_ShipmentID]);
//   //====================================================================

// useEffect(() => {
//   const fetchAllData = async () => {
//     try {
// //========== Newly Added ============
//       const storedData = sessionStorage.getItem('shipmentTable');
//        if (storedData) {
//         const parsedData = JSON.parse(storedData);
//         setSelectedShipmentsBySCP(parsedData);
//         return; 
//        }
// //===================================
//       // 1. Fetch data from Shipmentlist_vendor API
//       const shipmentResponse = await axios.get(
//         `${config.API_URL}/Shipmentlist_vendor/${SHPH_ShipmentID}`
//       );
//       const shipmentData = shipmentResponse.data.shipmentData;
//       logAction(`Shipment list fetched successfully`);
//       // Check for special scheme values
//       const hasSpecialScheme = shipmentData.some(item => 
//         item.OSM_SM_Value && item.SM_GiftArticle
//       );
      
//       if (hasSpecialScheme) {
//         // Store the special data for later use
//         const specialItems = shipmentData.filter(item => 
//           item.OSM_SM_Value && item.SM_GiftArticle
//         );
//         setShipmentSpecialData(specialItems);
        
//         // You can show an immediate popup or wait for scan completion
//         // For now, we'll show it when scan quantity matches ship quantity
//       }

//       // 2. Fetch RSN PackSize data
//       const scannedRSNResponse = await axios.get(
//         `${config.API_URL}/Scanned_RSN_PackSize_OF_Shipment_Outward/${SHPH_ShipmentID}/${selectedScpId}`
//       );
//       const rsnPackSizeData = scannedRSNResponse.data.AllRSN_ToOutward;

//       // 3. Fetch scanned RSN list
//       const scannedRandomNoResponse = await axios.get(
//         `${config.API_URL}/Scanned_RSN_OF_Shipment_Outward/${SHPH_ShipmentID}/${selectedScpId}`
//       );
//       const rsnRandomNoData = scannedRandomNoResponse.data.AllRSN_ToOutward;

//       // --- merge shipment data (your old logic) ---
//       const shipmentMap = {};
//       shipmentData.forEach((shipment) => {
//         const matchedRSN = rsnPackSizeData.find(
//           (rsn) =>
//             rsn.PL_ProductCode === shipment.SHPD_ProductCode &&
//             rsn.IRS_ToSCP === shipment.SHPD_SCPCode
//         );
//         const key = `${shipment.SHPD_ProductCode}-${shipment.SHPD_SCPCode}`;
//         if (!shipmentMap[key]) {
//           shipmentMap[key] = {
//             ...shipment,
//             SHPD_ShipQty: shipment.SHPD_ShipQty,
//             SHPD_ScanQty: matchedRSN
//               ? shipment.SHPD_ScanQty + matchedRSN.IRS_PackSize
//               : shipment.SHPD_ScanQty,
//           };
//         } else {
//           shipmentMap[key].SHPD_ShipQty += shipment.SHPD_ShipQty;
//           shipmentMap[key].SHPD_ScanQty += shipment.SHPD_ScanQty;
//         }
//       });

//       const mergedData = Object.values(shipmentMap);
//       setShipmentsBySCP(mergedData);

//       const rsnTreeDataRaw = await Promise.all(
//         rsnRandomNoData.map(async (rsn) => {
//           const resp = await axios.get(
//             `${config.API_URL}/RSNChainToMap/${rsn.IRS_RandomNo}`
//           );
//           return resp.data.data; // recursive tree from backend
//         })
//       );
      
//       // 🔥 Deduplicate by IRS_RandomNo
//       const uniqueTreeData = [];
//       const seen = new Set();
//       for (const node of rsnTreeDataRaw) {
//         if (!seen.has(node.IRS_RandomNo)) {
//           seen.add(node.IRS_RandomNo);
//           uniqueTreeData.push(node);
//         }
//       }
      
//       setRsnTree(uniqueTreeData); // save unique tree in state

//     } catch (error) {
//       console.error("Failed to fetch data:", error);
//     }
//   };

//   if (selectedScpId) {
//     fetchAllData();
//   }
// }, [SHPH_ShipmentID, selectedScpId, refreshTrigger]);

// //====================================================================

// // ADD THIS NEW USEEFFECT HOOK FOR AUTO-SELECTION
// useEffect(() => {
//   if (selectedShipmentsBySCP.length > 0) {
//     // If nothing is selected, auto-select the first available product
//     if (!SelectedShipmentID && !SelectedProductID) {
//       const firstAvailableProduct = selectedShipmentsBySCP.find(
//         shipment => shipment.SHPD_ShipQty > shipment.SHPD_ScanQty
//       );
      
//       if (firstAvailableProduct) {
//         setSelectedShipmentID(firstAvailableProduct.SHPD_ShipmentMID);
//         setSelectedProductID(firstAvailableProduct.PL_ProductId);
//         console.log("Auto-selected first product:", {
//           shipmentId: firstAvailableProduct.SHPD_ShipmentMID,
//           productId: firstAvailableProduct.PL_ProductId,
//           productName: firstAvailableProduct.SHPD_ProductName
//         });
//       }
//     } 
//     // Auto-switch to next available product when current one is saved
//     else {
//       const currentShipment = selectedShipmentsBySCP.find(
//         shipment => shipment.SHPD_ShipmentMID === SelectedShipmentID
//       );
      
//       if (currentShipment && currentShipment.SHPD_ShipQty === currentShipment.SHPD_ScanQty) {
//         const nextAvailableProduct = selectedShipmentsBySCP.find(
//           shipment => 
//             shipment.SHPD_ShipQty > shipment.SHPD_ScanQty && 
//             shipment.SHPD_ShipmentMID !== SelectedShipmentID
//         );
        
//         if (nextAvailableProduct) {
//           setSelectedShipmentID(nextAvailableProduct.SHPD_ShipmentMID);
//           setSelectedProductID(nextAvailableProduct.PL_ProductId);
//           console.log("Auto-switched to next product:", {
//             shipmentId: nextAvailableProduct.SHPD_ShipmentMID,
//             productId: nextAvailableProduct.PL_ProductId,
//             productName: nextAvailableProduct.SHPD_ProductName
//           });
          
//           // Show toast notification for auto-switch
//          // toast.info(`Auto-switched to: ${nextAvailableProduct.SHPD_ProductName}`);
//         }
//       }
//     }
//   }
// }, [selectedShipmentsBySCP, SelectedShipmentID, SelectedProductID]);

// //====================================================================
// const checkScanCompletionAndShowPopup = (updatedShipments) => {
//   // Check if any shipment with special scheme has reached scan completion
//   const completedSpecialShipments = updatedShipments.filter(shipment => {
//     const hasSpecialScheme = shipment.OSM_SM_Value && shipment.SM_GiftArticle;
//     const isCompleted = shipment.SHPD_ScanQty === shipment.SHPD_ShipQty;
//     return hasSpecialScheme && isCompleted;
//   });

//   if (completedSpecialShipments.length > 0) {
//     // Create popup message based on the special values
//     let message = "Special Scheme Alert!\n\n";
    
//     completedSpecialShipments.forEach(shipment => {
//       message += `Product: ${shipment.SHPD_ProductName}\n`;
//       if (shipment.OSM_SM_Value) {
//         message += `Scheme Value: ${shipment.OSM_SM_Value}\n`;
//       }
//       if (shipment.SM_GiftArticle) {
//         message += `Gift Article: ${shipment.SM_GiftArticle}\n`;
//       }
//       message += "Scanning saved for this product.\n\n";
//     });

//     message += "Please proceed with special handling as per the scheme.";

//     setSpecialPopupMessage(message);
//     setIsSpecialPopupVisible(false);
    
//     // Log the action
//     logAction(`Special scheme products saved scanning: ${completedSpecialShipments.map(s => s.SHPD_ProductName).join(', ')}`);
//   }
// };
// //   useEffect(() => {
// //   if (SelectedProduct && ShipmentsBySCP.length > 0) {
// //     const filteredShipmentsBySCP = ShipmentsBySCP.filter(
// //       (shipment) => shipment.SCPM_Name === SelectedProduct
// //     );
// //           setSelectedShipmentsBySCP((prevShipmentsBySCP) => [
// //         ...prevShipmentsBySCP,
// //         ...filteredShipmentsBySCP,
// //       ]);
// //   }
 
// // }, [SelectedProduct, ShipmentsBySCP]);
 
// useEffect(() => {
//      //============ Newly Added ============
//     if(SelectedProduct && ShipmentsBySCP.length > 0) {
//       const filteredShipmentsBySCP = ShipmentsBySCP.filter(
//         (shipment) => shipment.SCP_Name === SelectedProduct
//       );

//       const existingSCPIds = new Set(selectedShipmentsBySCP.map(item => `${item.SCP_Name}-${item.SHPD_ProductCode}`));
//       const newItems = filteredShipmentsBySCP.filter(item => 
//         !existingSCPIds.has(`${item.SCPM_Name}-${item.SHPD_ProductCode}`)
//       );
//       if(newItems.length > 0) {
//         setSelectedShipmentsBySCP((prevShipmentsBySCP) => [
//           ...prevShipmentsBySCP,
//           ...newItems,
//         ]);

//         // Store Updated Data in session storage 
//         const updatedData = [...selectedShipmentsBySCP, ...newItems];
//         sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedData));
//       }
//     }
//      //=====================================
//   },[SelectedProduct, ShipmentsBySCP]);

//   //====================================================================

//   //====================================================================
//   const [isPopupVisible, setPopupVisible] = useState(false);
//   const [confirmationCallback, setConfirmationCallback] = useState(null);
//   const [cancelCallback, setCancelCallback] = useState(null); // Cancel callback for "NO"
//   const [message, setMessage] = useState("");
//   const scannerInput = useRef("");

//   const showPopup = (message, onConfirm, onCancel) => {
//     setMessage(message);
//     setConfirmationCallback(() => onConfirm);
//     setCancelCallback(() => onCancel); // Assign cancel callback
//     setPopupVisible(true);
//   };

//   const handlePopupConfirm = () => {
//     if (confirmationCallback) confirmationCallback();
//     setPopupVisible(false);
//   };

//   const handlePopupClose = () => {
//     if (cancelCallback) cancelCallback(); // Run cancel callback if "NO" is clicked
//     setPopupVisible(false);
//   };

//   //====================================================================

//   const FetchVendorData = async (rsnValue , shipment, packSize) => {
//     console.log('this is the Product ID which you have clicked :', SelectedProductID)
//     console.log('This is the GTIN From Scanned Result :', ExtractedGTIN)
//     try {
//       if (!shipRandomrsn.getparentrsn) {
//         console.error("shipRandomrsn.getparentrsn is undefined");
//         return;
//       } 
      
//       if (SelectedShipmentID) {
//         if (!ExtractedGTIN) {
//           const RSNStatus = await fetch(
//           `${config.API_URL}/RSN_Status_Outward_NonGTIN/${shipRandomrsn.getparentrsn}/${selectedScpId}/${SelectedProductID}`
//         );
//         if (RSNStatus.ok) {
//           const data = await RSNStatus.json();
//           console.log("Fetched Data:", data);
//           if (data.IRS_Status === 6) {
//             const RES = await fetch(
//               `${config.API_URL}/ChildRSN_Lock_Outward/${data.IRS_RandomNo}`
//             );
//             if (RES.ok) {
//               const data = await RES.json();
//               console.log("Fetched Data:", data);
             
//             } else {
//               console.error("Error fetching the data");
//             }
//             const response = await fetch(
//               `${config.API_URL}/ParentRSN_PackSize_Outward/${data.IRS_RandomNo}`
//             );
//             if (response.ok) {
//               const data = await response.json();
//               console.log("Fetched Data from ParentRSN_PackSize:", data);
//               setFetchedData(data.PL_ProductCode);
//               //  if (shipment.SHPD_ScanQty + packSize > shipment.SHPD_ShipQty) {
//               if (data.IRS_ParentRandomNo) {
//                 // Show custom popup instead of window.confirm
//                 showPopup(
//                   "Are you sure you want to disaggregate the Parent RSN ?",
//                   async () => {
//                     try {
//                       const packSizeResponse = await fetch(
//                         `${config.API_URL}/ParentRSN_Disaggregation_Outward/${data.IRS_RandomNo}`
//                       );
//                       if (packSizeResponse.ok) {
//                         const packSizeData = await packSizeResponse.json();
//                         console.log(
//                           "Fetched Data from ParentRSN_Disaggregation:",
//                           packSizeData
//                         );
//                         setFetchedData(packSizeData.IRS_PackSize);
//                         setShipRandomrsn(packSizeData);
//                         HandleAddRSNinBox(
//                           packSizeData.IRS_PackSize,
//                           packSizeData.PL_ProductCode
//                         );
//                         logAction(
//                           ` All The Parent RSN of  ${data.IRS_RandomNo} of Shipment ID : ${SHPH_ShipmentID} disaggrigated successfully`
//                         );
//                       } else {
//                         console.error("Error fetching IRS_PackSize data");
//                       }
//                     } catch (error) {
//                       console.error("Error fetching IRS_PackSize data:", error);
//                     }
//                   },
//                   async () => {
//                     // Call when NO is clicked in popup
//                     console.log("NO clicked: running IRS Status update");
//                     try {
//                       const response = await fetch(
//                         `${config.API_URL}/Re_Update_Scanned_IRS_Status_Outward/${data.IRS_RandomNo}`,
//                         { method: "PUT" }
//                       );
//                       if (response.ok) {
//                         console.log(
//                           `IRS_Status updated successfully for value '${data.IRS_RandomNo}'`
//                         );
//                       } else {
//                         console.log(
//                           `Failed to update IRS_Status for value '${data.IRS_RandomNo}'`
//                         );
//                       }
//                     } catch (error) {
//                       console.error("Error updating IRS_Status:", error);
//                       console.log(
//                         `Failed to update IRS_Status for value '${data.IRS_RandomNo}'`
//                       );
//                     }
//                     setFetchedData("");
//                     setScannedResultForSCP("");
//                   }
//                 );
//               } else {
//                 console.log(
//                   "Setting IRS_PackSize directly:",
//                   data.IRS_PackSize
//                 );
//                 setFetchedData(data.IRS_PackSize);
//                 setShipRandomrsn(data);
//                 HandleAddRSNinBox(data.IRS_PackSize, data.PL_ProductCode);
//               }
//               // }
//             } else {
//               console.error("Error fetching the data");
//             }
//           } 
//           else if (data.IRS_Status === 22) {
//             if (!isRSNScanned) {
//               toast.warning("RSN already scanned");
//               logAction(`RSN  ${data.IRS_RandomNo} already exist`);
//               setScannedResultForSCP("");
//               return;
//             } else {
//               console.log("RSN Scanned");
//             }
//           }
//            else if (data.IRS_Status === 21) {
//             if (!isRSNScanned) {
//               toast.warning("Invalid RSN");
//               logAction(`Invalid RSN ${data.IRS_RandomNo}`);
//               return;
//             } else {
//               console.log("RSN Scanned");
//             }
//           } 
//          } else if (RSNStatus.status === 404) {
//           if (!isRSNScanned) {
//             toast.warning("Invalid RSN");
//             console.log("invalid RSN");
//             setScannedResultForSCP("");
//             console.error("Error fetching the RSN Status: No data found");
//             return;
//           } else {
//             console.log("RSN Scanned");
//           }
//         } else {
//           setScannedResultForSCP("");
//           console.error("Error fetching the RSN Status");
//         }
//       } else { 
//         const RSNStatus = await fetch(
//           `${config.API_URL}/RSN_Status_Outward/${shipRandomrsn.getparentrsn}/${selectedScpId}/${SelectedProductID}/${ExtractedGTIN}`
//         );
//         if (RSNStatus.ok) {
//           const data = await RSNStatus.json();
//           console.log("Fetched Data:", data);
//           if (data.IRS_Status === 6) {
//             const RES = await fetch(
//               `${config.API_URL}/ChildRSN_Lock_Outward/${data.IRS_RandomNo}`
//             );
//             if (RES.ok) {
//               const data = await RES.json();
//               console.log("Fetched Data:", data);
             
//             } else {
//               console.error("Error fetching the data");
//             }
//             const response = await fetch(
//               `${config.API_URL}/ParentRSN_PackSize_Outward/${data.IRS_RandomNo}`
//             );
//             if (response.ok) {
//               const data = await response.json();
//               console.log("Fetched Data from ParentRSN_PackSize:", data);
//               setFetchedData(data.PL_ProductCode);
//               if (data.IRS_ParentRandomNo) {
//                 showPopup(
//                   "Are you sure you want to disaggregate the Parent RSN ?",
//                   async () => {
//                     try {
//                       const packSizeResponse = await fetch(
//                         `${config.API_URL}/ParentRSN_Disaggregation_Outward/${data.IRS_RandomNo}`
//                       );
//                       if (packSizeResponse.ok) {
//                         const packSizeData = await packSizeResponse.json();
//                         console.log(
//                           "Fetched Data from ParentRSN_Disaggregation:",
//                           packSizeData
//                         );
//                         setFetchedData(packSizeData.IRS_PackSize);
//                         setShipRandomrsn(packSizeData);
//                         HandleAddRSNinBox(
//                           packSizeData.IRS_PackSize,
//                           packSizeData.PL_ProductCode
//                         );
//                         logAction(
//                           ` All The Parent RSN of  ${data.IRS_RandomNo} of Shipment ID : ${SHPH_ShipmentID} disaggrigated successfully`
//                         );
//                       } else {
//                         console.error("Error fetching IRS_PackSize data");
//                       }
//                     } catch (error) {
//                       console.error("Error fetching IRS_PackSize data:", error);
//                     }
//                   },
//                   async () => {
//                     // Call when NO is clicked in popup
//                     console.log("NO clicked: running IRS Status update");
//                     try {
//                       const response = await fetch(
//                         `${config.API_URL}/Re_Update_Scanned_IRS_Status_Outward/${data.IRS_RandomNo}`,
//                         { method: "PUT" }
//                       );
//                       if (response.ok) {
//                         console.log(
//                           `IRS_Status updated successfully for value '${data.IRS_RandomNo}'`
//                         );
//                       } else {
//                         console.log(
//                           `Failed to update IRS_Status for value '${data.IRS_RandomNo}'`
//                         );
//                       }
//                     } catch (error) {
//                       console.error("Error updating IRS_Status:", error);
//                       console.log(
//                         `Failed to update IRS_Status for value '${data.IRS_RandomNo}'`
//                       );
//                     }
//                     setFetchedData("");
//                     setScannedResultForSCP("");
//                   }
//                 );
//               } else {
//                 console.log(
//                   "Setting IRS_PackSize directly:",
//                   data.IRS_PackSize
//                 );
//                 setFetchedData(data.IRS_PackSize);
//                 setShipRandomrsn(data);
//                 HandleAddRSNinBox(data.IRS_PackSize, data.PL_ProductCode);
//               }
//               // }
//             } else {
//               console.error("Error fetching the data");
//             }
//           } 
//           else if (data.IRS_Status === 22) {
//             if (!isRSNScanned) {
//               toast.warning("RSN already scanned");
//               logAction(`RSN  ${data.IRS_RandomNo} already exist`);
//               setScannedResultForSCP("");
//               return;
//             } else {
//               console.log("RSN Scanned");
//             }
//           }
//            else if (data.IRS_Status === 21) {
//             if (!isRSNScanned) {
//               toast.warning("Invalid RSN");
//               logAction(`Invalid RSN ${data.IRS_RandomNo}`);
//               return;
//             } else {
//               console.log("RSN Scanned");
//             }
//           } 
//          } else if (RSNStatus.status === 404) {
//           if (!isRSNScanned) {
//             toast.warning("Invalid RSN");
//             console.log("invalid RSN");
//             setScannedResultForSCP("");
//             console.error("Error fetching the RSN Status: No data found");
//             return;
//           } else {
//             console.log("RSN Scanned");
//           }
//         } else {
//           setScannedResultForSCP("");
//           console.error("Error fetching the RSN Status");
//         }
//       }
//       } else {
//         toast.warning("Please Select a Product");
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };
//   //====================================================================

//   const handleInputModeChange = (mode) => {
//     setInputMode(mode);
//     setManualInputEnabled(mode === "manual");
//     setScannedResultForSCP(""); // Clear input field when switching mode
//     logAction(`Manual RSN Entry selected`);
//   };

//   useEffect(() => {
//     // Focus the input field whenever the inputMode changes
//     if (inputRef.current) {
//       inputRef.current.focus(); // Focus the input field
//     }
//     logAction(`Scanning RSN Entry selected`);
//   }, [inputMode]);
//   // const focusIntervalRef = useRef(null);
  

//   // useEffect(() => {
//   //   // Clear any existing interval
//   //   if (focusIntervalRef.current) {
//   //     clearInterval(focusIntervalRef.current);
//   //   }

//   //   // Set up new interval to focus input every 2 seconds
//   //   focusIntervalRef.current = setInterval(() => {
//   //     if (inputRef.current && (inputMode === "manual" || inputMode === "scan") && SelectedProduct) {
//   //       inputRef.current.focus();
//   //     }
//   //   }, 500);

//   //   // Cleanup interval on component unmount or when inputMode changes
//   //   return () => {
//   //     if (focusIntervalRef.current) {
//   //       clearInterval(focusIntervalRef.current);
//   //     }
//   //   };
//   // }, [inputMode, SelectedProduct]); // Re-run when inputMode or SelectedProduct changes

//   const handleManualSubmit = () => {
//     if (inputMode === "manual" && ScannedResultForSCP) {
//       FetchVendorData(ScannedResultForSCP);
//       if (
//         ScannedResultForSCP &&
//         !RSN.split("\n").includes(ScannedResultForSCP)
//       ) {
//         // Append the new value to the RSN list with a new line
//         setRSN((prevRSN) => prevRSN + "\n");
//         // Clear the input field after submission
//         setScannedResultForSCP("");
//         setTimeout(() => {
//           if (inputRef.current) {
//             inputRef.current.focus();
//           }
//         }, 0); // Ensure focus after state update
//       }
//     } else if (!ScannedResultForSCP || ScannedResultForSCP.trim() === "")  {
//       toast.warning("Please Enter RSN");
//     }
//   };

// const handleKeyDown = (e) => {
//   if (!e.key.match(/^[\r\n\t]*$/)) {
//     HandleScanChange(e); // Invoke your async handler
//   }
// };


//   useEffect(() => {
//     if (inputMode === "scan" && ScannedResultForSCP) {
//       if (debounceTimer.current) {
//         clearTimeout(debounceTimer.current);
//       }
//       debounceTimer.current = setTimeout(() => {
//         if (
//           ScannedResultForSCP &&
//           !RSN.split("\n").includes(ScannedResultForSCP)
//         ) {
//           setRSN((prevRSN) => prevRSN + "\n");
//           setScannedResultForSCP("");
//         }
//         FetchVendorData(ScannedResultForSCP);
//         setScannedResultForSCP("");
//       }, 500); // 1 second delay
//       return () => {
//         if (debounceTimer.current) {
//           clearTimeout(debounceTimer.current);
//         }
//       };
//     }
//   }, [ScannedResultForSCP, shipRandomrsn.getparentrsn, inputMode]);

//   const HandleInputChange = async (e) => {
//     const scannedValue = e.target.value;
    
//     setScannedResultForSCP(scannedValue);
//     setShipRandomrsn({ getparentrsn: scannedValue });
//     setFetchedData("");
//   };

// let scanTimeout;


//   // const [ScannedResultForSCP, setScannedResultForSCP] = useState(null);
//   // const [shipRandomrsn, setShipRandomrsn] = useState({ getparentrsn: "" });
// // the Etire things are required to be checked before apply 
// const HandleScanChange = (e) => {
//   const scannedValue = e.target.value.trim();
//   if (scanTimeout) clearTimeout(scanTimeout);

//   scanTimeout = setTimeout(() => {
//     // Match RSN: (21|00) followed by 8–25 alphanumeric characters until (01|10|17) or end
//     const rsnMatch = scannedValue.match(/\((21|00)\)([A-Z0-9]{8,25})(?=\(01\)|\(10\)|\(17\)|$)/i);

//     // Match GTIN: (01) followed by 8–25 digits
//     const gtinMatch = scannedValue.match(/\(01\)(\d{8,25})/);

//     let extractedRSN = "";
//     let extractedGTIN = null;

//     if (rsnMatch && /^[A-Z0-9]{8,25}$/.test(rsnMatch[2])) {
//       extractedRSN = rsnMatch[2];
//     } else if (/^[A-Z0-9]{8,25}$/i.test(scannedValue)) {
//       extractedRSN = scannedValue;
//     }

//     if (gtinMatch && /^\d{8,25}$/.test(gtinMatch[1])) {
//       extractedGTIN = gtinMatch[1];
//     }

//     if (extractedRSN) {
//       setScannedResultForSCP(extractedRSN);
//       setShipRandomrsn({ getparentrsn: extractedRSN });
//       setFetchedData("");
//       console.log("Extracted RSN:", extractedRSN);
//     } else {
//       console.warn("Invalid or corrupted RSN");
//       setScannedResultForSCP("");
//     }

//     if (extractedGTIN) {
//       setExtractedGTIN(extractedGTIN);
//       console.log("Extracted GTIN:", extractedGTIN);
//     } else {
//       setExtractedGTIN(null);
//     }

//     if (inputRef.current) inputRef.current.value = "";
//   }, 50);
// };

// // const HandleScanChange = (e) => {
// //   const scannedValue = e.target.value.trim();
// //   if (scanTimeout) clearTimeout(scanTimeout);

// //   scanTimeout = setTimeout(() => {
// //     // Match RSN from (21) or (00) followed by 8–25 alphanumeric characters
// //     // until it hits (01), (10), (17), or end of string
// //     const bracketedMatch = scannedValue.match(/\((21|00)\)([A-Z0-9]{8,25})(?=\(01\)|\(10\)|\(17\)|$)/i);

// //     let extracted = '';
// //     if (bracketedMatch && /^[A-Z0-9]{8,25}$/.test(bracketedMatch[2])) {
// //       extracted = bracketedMatch[2];
// //     } else if (/^[A-Z0-9]{8,25}$/i.test(scannedValue)) {
// //       extracted = scannedValue;
// //     }

// //     if (extracted) {
// //       setScannedResultForSCP(extracted);
// //       setShipRandomrsn({ getparentrsn: extracted });
// //       setFetchedData('');
// //       console.log('Extracted RSN:', extracted);
// //     } else {
// //       console.warn('Invalid or corrupted RSN');
// //       setScannedResultForSCP('');
// //     }
// //     if (inputRef.current) inputRef.current.value = '';
// //   }, 50);
// // };


//   const preventPaste = (e) => {
//     e.preventDefault();
//   };

// const HandleAddRSNinBox = async (packSize, productCode) => {
//   if (ScannedResultForSCP && !UniqueRSN.has(ScannedResultForSCP)) {
//     let found = false;
//     let updatedProductShipment = [...selectedShipmentsBySCP];

//     if (SelectedShipmentID && SelectedProductID) {
//       updatedProductShipment = updatedProductShipment.map((shipment) => {
//         if (
//           shipment.SHPD_ShipmentMID === SelectedShipmentID &&
//           SelectedProductID === shipment.PL_ProductId
//         ) {
//           if (shipment.SHPD_ScanQty + packSize > shipment.SHPD_ShipQty) {
//             toast.warning('Scanning limit reached');
//             logAction(
//               `Scan Quantity reached the limit please select another product`
//             );
//             return shipment;
//           } else {
//             found = true;
//             return{
//               ...shipment,
//               SHPD_ScanQty: shipment.SHPD_ScanQty + packSize
//             };
//           }
//         }
//         return shipment;
//       });
//     } else {
//       updatedProductShipment = updatedProductShipment.map((shipment) => {
//         if (shipment.SHPD_ProductCode === productCode) {
//           if (shipment.SHPD_ScanQty + packSize > shipment.SHPD_ShipQty) {
//             toast.warning('Scanning limit reached');
//             logAction(
//               'Scan Quantity reached the limit please select another product'
//             );
//             return shipment;
//           } else {
//             found = true;
//             return {
//               ...shipment,
//               SHPD_ScanQty: shipment.SHPD_ScanQty + packSize
//             };
//           }
//         }
//         return shipment;
//       });
//     }
//     if (found) {
//       setRSN((prevContent) => {
//         const updated = prevContent +ScannedResultForSCP + "\n";
//         const uniqueLines = [...new Set(updated.split("\n").filter((l) => l.trim() !==""))];
//         return uniqueLines.join("\n");
//       });
//       setScannedResultForSCP("");
//       setUniqueRSN((prevSerials) => new Set(prevSerials.add(ScannedResultForSCP)));
//       logAction(
//         `RSN : ${ScannedResultForSCP} is Scanned For Shipment ID : ${SHPH_ShipmentID}`
//       );
//       await fetchShipmentRSNLockForChild(SelectedShipmentID);
//       await fetchShipmentRSNLockForParentRSN(SelectedShipmentID);
//       try {
//         const resp = await axios.get(
//           `${config.API_URL}/RSNChainToMap/${ScannedResultForSCP}`
//         );
//         const newChain = resp.data.data;

//         setRsnTree((prevTree) => {
//           if (!prevTree || prevTree.length === 0) return [newChain];
//           const exists = prevTree.some(
//             (root) => root.IRS_RandomNo === newChain.IRS_RandomNo
//           );
//           return exists ? prevTree : [...prevTree, newChain];
//         });
//       } catch (err) {
//         console.error("Faild To fetch RSN chain for new RSN :", err);
//       }
//       setSelectedShipmentsBySCP(updatedProductShipment);
//       checkScanCompletionAndShowPopup(updatedProductShipment);
//       // Update the session storage  with the updated shipents 
//       sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedProductShipment));
//     } else {
//       setNotAddedValues((prevValues) => [...prevValues, ScannedResultForSCP]);
//       await updateScannedIRSStatus();
//     }
//   } else if  (!ScannedResultForSCP) {
//     await updateScannedIRSStatus();
//   } else {
//     await updateScannedIRSStatus();
//   }
// };





//   const updateScannedIRSStatus = async () => {
//     try {
//       const response = await axios.put(
//         `${config.API_URL}/Update_Bymistake_Scanned_RSN/${ScannedResultForSCP}`
//       );
//       if (response.status === 200) {
//         console.log(
//           `IRS_Status updated successfully for value '${ScannedResultForSCP}'`
//         );
//       } else {
//         console.log(
//           `Failed to update IRS_Status for value '${ScannedResultForSCP}'`
//         );
//       }
//     } catch (error) {
//       console.error("Error updating IRS_Status:", error);
//       console.error(
//         `Failed to update IRS_Status for value '${ScannedResultForSCP}'`
//       );
//     }
//   };
//   useEffect(() => {
//     const updateIRSStatus = async () => {
//       try {
//         for (const value of notAddedValues) {
//           const response = await axios.put(
//             `${config.API_URL}/Re_Update_Scanned_IRS_Status_Outward/${value}`
//           );
//           if (response.status === 200) {
//             console.log(
//               `IRS_Status updated successfully for value '${ScannedResultForSCP}'`
//             );
//           } else {
//             console.log(
//               `Failed to update IRS_Status for value '${ScannedResultForSCP}'`
//             );
//           }
//         }
//         // Clear notAddedValues after updating IRS_Status for all values
//         setNotAddedValues("");
//       } catch (error) {
//         console.error("Error updating IRS_Status:", error);
//       }
//     };
//     // Call the updateIRSStatus function when notAddedValues changes
//     if (notAddedValues.length > 0) {
//       updateIRSStatus();
//     }
//   }, [notAddedValues]);

//   const handleCheckBoxChange = (e, item) => {
//     if (e.target.checked) {
//       setCheckedItems((prevCheckedItems) =>
//         new Set(prevCheckedItems).add(item)
//       );
//     } else {
//       const newCheckedItems = new Set(CheckedItems);
//       newCheckedItems.delete(item);
//       setCheckedItems(newCheckedItems);
//       sessionStorage.removeItem("RSN");
//       sessionStorage.removeItem("CheckedItems");
//     }
//   };


// const handleSelectAllChange = (e) => {
//   if (e.target.checked) {
//     let allItems = new Set();

//     // 1. Include all RSNs from textarea
//     RSN.split("\n")
//       .filter((line) => line.trim() !== "")
//       .forEach((line) => allItems.add(line));

//     // 2. Include all root + children from rsnTree
//     const collectAllNodes = (node) => {
//       allItems.add(node.IRS_RandomNo);
//       if (node.children && node.children.length > 0) {
//         node.children.forEach(collectAllNodes);
//       }
//     };
//     if (rsnTree) {
//       rsnTree.forEach(collectAllNodes);
//     }
//     setCheckedItems(allItems);
//   } else {
//     setCheckedItems(new Set());
//   }
// };

//   // const handleSCPChange = async (selectedOption) => {
//   //   const selectedProduct = selectedOption?.value; // Get the value from the selected option
//   //   setSelectedProduct(selectedProduct);

//   //   // Disable the selected option in the SCPNames list
//   //   setSCPNames((prevSCPNames) =>
//   //     prevSCPNames.map((option) =>
//   //       option.value === selectedProduct
//   //         ? { ...option, isDisabled: true }
//   //         : option
//   //     )
//   //   );

//   //   setManualInputEnabled(false); // Disable manual input
//   // };

//   const handleSCPChange = async (selectedOption) => {
//     const selectedProduct = selectedOption?.value;
//     setSelectedProduct(selectedProduct);
// //=========== Newly Added =============================
//     if (selectedProduct && ShipmentsBySCP.length > 0) {
//       const filteredShipmentsBySCP = ShipmentsBySCP.filter(
//         (shipment) => shipment.SCPM_Name === selectedProduct
//       );

//       const existingSCPIds = new Set(selectedShipmentsBySCP.map(item => `${item.SCPM_Name}-${item.SHPD_ProductCode}`));
//       const newItems = filteredShipmentsBySCP.filter(item => 
//         !existingSCPIds.has(`${item.SCPM_Name}-${item.SHPD_ProductCode}`)
//       );
//       if (newItems.length > 0) {
//         setSelectedShipmentsBySCP((prevShipmentsBySCP) => [
//           ...prevShipmentsBySCP,
//           ...newItems,
//         ]);
//         const updatedData = [...selectedShipmentsBySCP, ...newItems];
//         sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedData));
//       }
//     }
// //====================================================
//   setSCPNames((prevSCPNames) => 
//     prevSCPNames.map((option) => 
//       option.value === selectedProduct
//          ? { ...option, isDisabled: true }
//          : option 
//     )
//   );
//  setManualInputEnabled(false);    
// }
  
// const removeSelectedItemsAndUpdateStatus = async () => {
//   console.log("Before-",selectedShipmentsBySCP)
//   try {
//     const selectedItems = Array.from(CheckedItems);

//     // Check if there are any selected items
//     if (selectedItems.length === 0) {
//       toast.warn("Please select a minimum one serial number");
//       logAction("Please select a minimum one serial number");
//       return;
//     }

//     // --- API call to update status in backend ---
//     const response = await axios.put(
//       `${config.API_URL}/Update_Removed_RSN_Status_Outward`,
//       {
//         IRS_RandomNos: selectedItems,
//       }
//     );

//     if (response.status === 200) {
//       console.log("IRS_Status updated successfully for the selected items");
//       logAction(
//         `IRS_Status updated successfully for the selected items ${selectedItems}`
//       );

//       // --- Update shipments ---
//       const { packSizes } = response.data;
//       const totalPackSizeByProduct = packSizes.reduce((acc, packSize) => {
//         const { PL_ProductCode, IRS_PackSize, SHPD_SCPCode } = packSize;
//         const key = `${PL_ProductCode}-${SHPD_SCPCode}`;
//         acc[key] = (acc[key] || 0) + IRS_PackSize;
//         return acc;
//       }, {});

//       const updatedShipments = selectedShipmentsBySCP.map((shipment) => {
//         const key = `${shipment.SHPD_ProductCode}-${shipment.SHPD_SCPCode}`;
//         const totalPackSize = totalPackSizeByProduct[key] || 0;
//         shipment.SHPD_ScanQty = Math.max(
//           0,
//           shipment.SHPD_ScanQty - totalPackSize
//         );
//         return shipment;
//       });

//       setSelectedShipmentsBySCP(updatedShipments);
//       sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedShipments));
//       // --- Update child RSN status in backend ---
//       await axios.post(`${config.API_URL}/ChildRSN_Status_OutwardScan`, {
//         IRS_RandomNos: selectedItems,
//       });

//       // --- Update RSN textarea ---
//       const remainingRSN = RSN.split("\n")
//         .map((line) => line.trim())
//         .filter((line) => !selectedItems.includes(line)) // FIX: use selectedItems
//         .join("\n");

//       setRSN(remainingRSN.trim());

//       // --- Update rsnTree (box UI) ---
//       setRsnTree((prevTree) => {
//         if (!prevTree) return prevTree;

//         // Recursive child remover
//         const removeNodes = (node) => {
//           if (!node.children) return node;
//           return {
//             ...node,
//             children: node.children
//               .filter((child) => !selectedItems.includes(child.IRS_RandomNo))
//               .map((child) => removeNodes(child)),
//           };
//         };

//         // Remove roots + clean children
//         return prevTree
//           .filter((root) => !selectedItems.includes(root.IRS_RandomNo))
//           .map((root) => removeNodes(root));
//       });

//       // --- Clear checkboxes ---
//       setCheckedItems(new Set());

//       // --- Update UniqueRSN ---
//       selectedItems.forEach((item) => {
//         if (UniqueRSN.has(item)) {
//           UniqueRSN.delete(item);
//         }
//       });

//       toast.success(`Selected RSN removed successfully`);

//       // --- Reset Select All checkbox ---
//       const selectAllCheckbox = document.getElementById("selectAll");
//       if (selectAllCheckbox) {
//         selectAllCheckbox.checked = false;
//       }

//       // --- Trigger UI refresh for input ---
//       setRefreshTrigger((prev) => prev + 1);
//       document.getElementById("RSNInput")?.dispatchEvent(new Event("input"));
//        setTimeout(() => {
//         // window.location.reload();
//       }, 1000);
//     } else {
//       console.error("Failed to update IRS_Status for the selected items");
//     }
//   } catch (error) {
//     console.error("Error updating IRS_Status:", error);
//   }
//   console.log("After-",selectedShipmentsBySCP)
// };

//   const updateScanQuantity = async (shipment) => {
//     const {
//       SHPD_ShipmentID,
//       SHPD_ProductCode,
//       SHPD_ScanQty,
//       SHPH_ShipmentCode,
//     } = shipment;

//     try {
//       // Step 1: Update scan quantity
//       const updateScanResponse = await axios.put(
//         `${config.API_URL}/Update_Scanqty_Outward`,
//         {
//           SHPD_ShipmentID,
//           SHPD_ProductCode,
//         }
//       );

//       if (updateScanResponse.status !== 200) {
//         console.log(
//           `Failed to update scan quantity for Shipment ID ${SHPD_ProductCode}`
//         );
//         logAction(
//           `Failed to update scan quantity for Shipment ID ${SHPD_ProductCode}`
//         );
//         return;
//       }
//       //======================================
//       //======================================
//       console.log("Function is called");
//       const details = {
//         AUTR_Message: `Shipment ${SHPH_ShipmentCode} Completed`,
//         AUTR_AuditType: "insert",
//         AUTR_NewValue: "",
//         AUTR_OldValue: "-",
//       };
//       let id = await audittrailpost(details);

//       const logAuditTrail = (message, id, newValue, oldValue) => {
//         const details = {
//           AUTRN_ParamererName: message,
//           AUTRN_ID: id,
//           AUTRN_NewValue: newValue,
//           AUTRN_OldValue: oldValue,
//         };
//         audittransection(details);
//       };

//       logAuditTrail("Shipment ", id, SHPH_ShipmentCode, "-");
//       console.log("Function is called ");
//       //========================================
//       //========================================
//       const { SHPH_FromSCPCode, PL_ProductId } =
//         updateScanResponse.data.updatedData;

//       // Step 2: Fetch inventory data
//       const inventoryResponse = await axios.get(
//         `${config.API_URL}/Inventory_Outward/${SHPH_FromSCPCode}/${PL_ProductId}`
//       );

//       if (inventoryResponse.status !== 200) {
//         console.log(
//           `Failed to fetch inventory data for SCPID ${SHPH_FromSCPCode} and Product ID ${PL_ProductId}`
//         );
//         return;
//       }

//       const inventoryData = inventoryResponse.data.inventorydata[0];
//       const { inv_blockqty, inv_availableqty } = inventoryData;

//       const updatedBlockQty = inv_blockqty - SHPD_ScanQty;
//       const updatedAvailableQty = inv_availableqty - SHPD_ScanQty;

//       // Step 4: Update inventory data
//       const updateInventoryResponse = await axios.put(
//         `${config.API_URL}/Inventory_Outward/${SHPH_FromSCPCode}/${PL_ProductId}`,
//         {
//           inv_blockqty: updatedBlockQty,
//           inv_availableqty: updatedAvailableQty,
//         }
//       );

//       if (updateInventoryResponse.status !== 200) {
        
//         console.log(
//           `Failed to update inventory for SCPID ${SHPH_FromSCPCode} and Product ID ${PL_ProductId}`
//         );
//         return;
//       }
//       // Step 5: Display success message
//       // toast.success(`Shipment : ${SHPH_ShipmentCode} saved successfully`);
//       toast.success(`Shipment : ${SHPH_ShipmentCode} saved successfully`, {
//         toastId: `shipment-${SHPD_ShipmentID}`,
//       });

//       logAction(`Shipment : ${SHPH_ShipmentCode} saved successfully`);

//       setTimeout(() => {
//         navigate("/ShipOutScanPendingList");
//       }, 2000);
//     } catch (error) {
//       console.error(
//         `Error processing request for Shipment ID ${SHPD_ShipmentID}:`,
//         error
//       );
//       toast.error(
//         `Failed to process request for Shipment  ${SHPH_ShipmentCode}`
//       );
//       logAction(`Failed to process request for Shipment  ${SHPH_ShipmentCode}`);
//     }
//   };

//   // ==================== Used For Shipment Lock =========================
//   const fetchShipmentRSNLockForChild = async (SelectedShipmentID) => {
//     try {
//       const response = await axios.get(
//         `${config.API_URL}/ShipmentData_For_RSN_Outward/${SelectedShipmentID}/${SHPH_ShipmentID}`
//       );
//       const shipmentData = response.data.ShipmentForRSN;
//       console.log("Shipment Data:", shipmentData);
//       for (const item of shipmentData) {
//         await axios.put(
//           `${config.API_URL}/ChildRSNLockToShipMentID_Outward/${shipRandomrsn.getparentrsn}`,
//           {
//             IRS_ShipmentID: item.IRS_ShipmentID,
//             IRS_ToSCP: item.IRS_ToSCP,
//             IRS_PhysicalLocation: item.IRS_PhysicalLocation,
//           }
//         );
//       }
//     } catch (error) {
//       console.error("Error fetching shipment data:", error);
//     }
//   };

//   const fetchShipmentRSNLockForParentRSN = async (SelectedShipmentID) => {
//     try {
//       const response = await axios.get(
//         `${config.API_URL}/ShipmentData_For_RSN_Outward/${SelectedShipmentID}/${SHPH_ShipmentID}`
//       );
//       const shipmentData = response.data.ShipmentForRSN;
//       console.log("Shipment Data:", shipmentData);

//       for (const item of shipmentData) {
//         await axios.put(
//           `${config.API_URL}/ParentRSNLockToShipMentID_Outward/${shipRandomrsn.getparentrsn}`,
//           {
//             IRS_ShipmentID: item.IRS_ShipmentID,
//             IRS_ToSCP: item.IRS_ToSCP,
//             IRS_PhysicalLocation: item.IRS_PhysicalLocation,
//           }
//         );
//         const packSizeResponse = await axios.get(
//           `${config.API_URL}/ParentRSN_Lock_Update_Outward/${shipRandomrsn.getparentrsn}/${item.IRS_ShipmentID}/${item.IRS_ToSCP}`
//         );

//         if (packSizeResponse.status === 200) {
//           const packSizeData = packSizeResponse.data;
//           console.log(
//             "Fetched Data from ParentRSN_Disaggregation:",
//             packSizeData
//           );
//           //=======================//===================//===============//
//           const parentRSNResponse = await fetch(
//             `${config.API_URL}/Disaggrigated_RSN_History_Outward`,
//             {
//               method: "POST",
//               headers: {
//                 "Content-Type": "application/json",
//               },
//               body: JSON.stringify({
//                 IRS_RandomNo: shipRandomrsn.getparentrsn,
//               }),
//             }
//           );
//           const parentRSNData = await parentRSNResponse.json();
//           if (parentRSNResponse.ok && parentRSNData.IRS_ParentRandomNo) {
//             const parentRandomNo = parentRSNData.IRS_ParentRandomNo;
//             logAction(
//               `The Parent RSN : ${parentRandomNo.join(", ")} of RSN ${
//                 shipRandomrsn.getparentrsn
//               } of Shipment ID : ${SHPH_ShipmentID} Disaggregated Successfully`
//             );
//           }
//           //=======================//===================//===============//

//           console.log(
//             "ShipmentID",
//             item.IRS_ShipmentID,
//             "SHPD SCP ID",
//             item.IRS_ToSCP
//           );
//         } else {
//           console.error("Error fetching IRS_PackSize data");
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching shipment data:", error);
//     }
//   };


  
//   const [saveCallCount, setSaveCallCount] = useState(0); // Initialize call count state
  
//   const handleSave = async (e) => {
//   e.preventDefault();
  
//   // Check if the function has already been called
//   if (saveCallCount > 0) {
//     console.log("handleSave function already called, ignoring subsequent calls.");
//     return; // Disable further execution
//   }
  
//   // Increase the call count
//   setSaveCallCount((prevCount) => prevCount + 1);
  
//   try {
//     // First update scan quantities
//     for (const shipment of selectedShipmentsBySCP) {
//       await updateScanQuantity(shipment);
//     }
//     checkScanCompletionAndShowPopup(selectedShipmentsBySCP);
//     // Then insert IRS info
//     await callInsertIRSInfoAPI();
    
//     console.log("Shipment Outward Scanning Completed");
    
//     // Clear session storage
//     sessionStorage.removeItem('shipmentTableData');
//     setIsSaveButtonDisabled(true);
//   } catch (error) {
//     console.error("Error updating scan quantities:", error);
//     toast.error("Failed to complete the shipment");
    
//     // Reset the call count on error to allow retry
//     setSaveCallCount(0);
//   }
// };
//   //==========================================================

//   const callInsertIRSInfoAPI = async () => {
//   // Collect RSNs from textarea
//   const textareaRSNs = Array.from(
//     new Set(RSN.split("\n").filter((line) => line.trim() !== ""))
//   );
  
//   // Collect RSNs from rsnTree (including all children)
//   const treeRSNs = [];
//   const collectAllNodes = (node) => {
//     treeRSNs.push(node.IRS_RandomNo);
//     if (node.children && node.children.length > 0) {
//       node.children.forEach(collectAllNodes);
//     }
//   };
  
//   if (rsnTree) {
//     rsnTree.forEach(collectAllNodes);
//   }
  
//   // Combine and deduplicate all RSNs
//   const allRSNValues = Array.from(new Set([...textareaRSNs, ...treeRSNs]));
  
//   if (allRSNValues.length === 0) {
//     console.log("No RSNs available to insert.");
//     return;
//   }
  
//   console.log("Calling IRS info API with RSNs:", allRSNValues);
  
//   try {
//     const response = await axios.post(
//       `${config.API_URL}/All_RSN_History_Insertion_Outward`,
//       {
//         IRS_RandomNos: allRSNValues, // Send all RSNs to the API
//       }
//     );
    
//     if (response.status === 200) {
//       console.log(
//         "Data successfully inserted into rsnhistoryinfo:",
//         response.data
//       );

//       const RackSpace = await axios.get(
//         `${config.API_URL}/RackSpace_Shipment_Outward/${SHPH_ShipmentID}/${selectedScpId}`
//       );
      
//       if (RackSpace.status === 200) {
//         console.log(`Logical Location updated successfully `);
//       } else {
//         console.log(`Failed to update Logical Location `);
//       }

//       logAction("IRS info inserted successfully");
//     } else {
//       console.log("Failed to insert IRS info:", response);
//     }
//   } catch (error) {
//     console.error("Error inserting IRS info:", error);
//     logAction("Failed to insert IRS info");
//   }
// };
//   //==========================================================
 
//   const isSaveButtonVisible = () => {
//     return selectedShipmentsBySCP.every(
//       (shipment) => shipment.SHPD_ShipQty === shipment.SHPD_ScanQty
//     );
//   };
//   const [isSelectOpen, setIsSelectOpen] = useState(false);
//   const handleSelectOpen = (selectName) => {
//     setIsSelectOpen(selectName);
//   };

//   const handleSelectClose = () => {
//     setIsSelectOpen(null);
//   };
// const handleRowClick = (shipment) => {
//   // Save clicked shipment + product info in state
//   setSelectedShipmentID(shipment.SHPD_ShipmentMID);
//   setSelectedProductID(shipment.PL_ProductId);

//   console.log("Row clicked →", {
//     shipmentId: shipment.SHPD_ShipmentMID,
//     productId: shipment.PL_ProductId,
//     productCode: shipment.SHPD_ProductCode,
//     productName: shipment.SHPD_ProductName,
//   });

// };

//   return (
//     <>
//       {/* <Sto /> */}
//       <ToastContainer
//         style={{
//           marginTop: "73px",
//           fontSize: "14px",
//           width: "40%",
//         }}
//       />
//       <div className="main_container">
//         <h4 className="formHeading"> Vendor wise scanning </h4>
//         <div className="">
//           <div className="row">
//             <div className="col-md-4">
//               <div className="mb-3">
//                 <label className="form-label">SCP Name</label>
//                 <div className="select-container">
//                   <Select
//                     options={SCPNames}
//                     value={SCPNames.find(
//                       (option) => option.value === SelectedProduct
//                     )}
//                     onChange={handleSCPChange}
//                     placeholder="Select SCP Name"
//                     className="routing_select-box"
//                     isSearchable
//                     isOptionDisabled={(option) => option.isDisabled} // Disable already-selected options
//                     styles={{
//                       option: (base, state) => ({
//                         ...base,
//                         color: state.isDisabled ? "#999" : base.color,
//                         backgroundColor: state.isDisabled
//                           ? "#fff"
//                           : base.backgroundColor,
//                         cursor: state.isDisabled ? "not-allowed" : "default",
//                       }),
//                     }}
//                     onMenuOpen={() => handleSelectOpen('scpName')}
//                     onMenuClose={handleSelectClose}
//                 />
//                 <div className='icon-container'>
//                     {isSelectOpen === 'scpName' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
//                 </div>
//                 </div>
//               </div>
//             </div>

//             <div className="col-md-4">
//               <div className="mb-3">
//                 <div className="d-flex align-items-center">
//                   <label
//                     className="form-label"
//                     style={{ marginBottom: "-5px" }}
//                   >
//                     RSN
//                   </label>
//                   <div
//                     style={{
//                       display: "inline-flex",
//                       alignItems: "center",
//                       marginRight: "-25px",
//                     }}
//                   >
//                     <input
//                       type="radio"
//                       name="inputMode"
//                       value="manual"
//                       checked={inputMode === "manual"}
//                       onChange={() => handleInputModeChange("manual")}
//                       style={{
//                         accentColor: "black",
//                         marginRight: "-25px",
//                       }}
//                     />
//                     <label style={{ margin: "0" }}>Manual</label>
//                   </div>
//                   <div
//                     style={{
//                       display: "inline-flex",
//                       alignItems: "center",
//                       marginRight: "-25px",
//                     }}
//                   >
//                     <input
//                       type="radio"
//                       name="inputMode"
//                       value="scan"
//                       checked={inputMode === "scan"}
//                       onChange={() => handleInputModeChange("scan")}
//                       style={{
//                         accentColor: "black",
//                         marginRight: "-25px",
//                       }}
//                     />
//                     <label style={{ margin: "0" }}>Scan</label>
//                   </div>
//                 </div>

//                 {/* Manual Input Field */}
//                 {inputMode === "manual" && (
//                   <div className="d-flex align-items-center mt-2">
//                     <div
//                       className="input-group"
//                       style={{ flexGrow: 1, marginRight: "10px" }}
//                     >
//                       <input
//                         type="text"
//                         className="form-input"
//                         placeholder="Enter RSN"
//                         ref={inputRef} // Use the inputRef to reference this input element
//                         value={ScannedResultForSCP || ""}
//                         onChange={HandleInputChange}
//                         disabled={!SelectedProduct && !manualInputEnabled} // Disabled until product is selected or manual input is enabled
//                         style={{ width: "100%" }}
//                       />
//                     </div>
//                     <button
//                       className="btn btn-dark"
//                       onClick={handleManualSubmit}
//                     >
//                       SUBMIT
//                     </button>
//                   </div>
//                 )}

//                 {/* Scan Input Field */}
//                 {inputMode === "scan" && (
//                   <div className="d-flex align-items-center mt-2">
//                     <div
//                       className="input-group"
//                       style={{ flexGrow: 1, marginRight: "10px" }}
//                     >
                      
//                    <input
//                      type="text"
//                      className="form-input"
//                      placeholder="Scan RSN"
//                      ref={inputRef}
//                      defaultValue=""
//                      onChange={HandleScanChange}
//                      onPaste={preventPaste}
//                      onKeyDown={handleKeyDown}
//                      disabled={!SelectedProduct}
//                      style={{ width: "100%" }}
//                    />
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
    
//           </div>
//         </div>
//         {isGift?.SCPM_Name && isGift.SCPM_Name.length > 0 ? (
//         isGift.SCPM_Name.some(
//           (item) => item.SM_GiftArticle && item.OSM_SM_Value
//         ) ? (
//           isGift.SCPM_Name.map((item) =>
//             item.SM_GiftArticle && item.OSM_SM_Value ? (
//               <p key={item.SCPM_ID} style={{ color: "green", fontWeight: "bold" }}>
//                 Hope you have packed {item.OSM_SM_Value} × {item.SM_GiftArticle} for SCP{" "}
//                 {item.SCPM_Name} {/*({item.SCPM_ID})*/}
//               </p>
//             ) : null
//           )
//         ) : (
//           <p></p>
//         )
//       ) : (
//         <p>Loading...</p>
//       )}
//         <div className="row mt-3">
//           <div className="col-md-9">
//             <div className="tableScanContainer">
//               <table className="scantableClass">
//                 <thead>
//                   <tr>
//                     <th>Sr. No.</th>
//                     <th className="nav-tabs">SCP Name</th>
//                     <th className="nav-tabs">Product Name </th>
//                     <th className="nav-tabs">Product Code </th>
//                     <th className="nav-tabs">Available Qty</th>
//                     <th className="nav-tabs">Scanned Qty</th>
//                     <th className="nav-tabs">Shipment Qty</th>
//                   </tr>
//                 </thead>
//                 {/* <tbody>
//                   {selectedShipmentsBySCP.map((shipment, index) => (
//                     <tr
//                       key={shipment.SHPD_ShipmentMID}
//                       onClick={() => handleRowClick(shipment)}
//                       className={
//                         SelectedShipmentID === shipment.SHPD_ShipmentMID
//                           ? "highlight"
//                           : ""
//                       }
                      
//                     >
//                       <td>{index + 1}</td>
//                       <td>{shipment.SCPM_Name}</td>
//                       <td>{shipment.SHPD_ProductName}</td>
//                       <td>{shipment.SHPD_ProductCode}</td>
//                       <td>{shipment.inv_availableqty}</td>
//                       <td>{shipment.SHPD_ScanQty}</td>
//                       <td>{shipment.SHPD_ShipQty}</td>
//                     </tr>
//                   ))}
//                 </tbody> */}
//                 <tbody>
//                   {selectedShipmentsBySCP.map((shipment, index) => {
//                     const isSelected = SelectedShipmentID === shipment.SHPD_ShipmentMID;
//                     const isCompleted = shipment.SHPD_ShipQty === shipment.SHPD_ScanQty;
                    
//                     return (
//                       <tr
//                         key={shipment.SHPD_ShipmentMID}
//                         onClick={() => handleRowClick(shipment)}
//                         className={
//                           isSelected 
//                             ? isCompleted ? "highlight" : "auto-highlight" 
//                             : ""
//                         }
//                         style={{
//                           cursor: isCompleted ? 'not-allowed' : 'pointer',
//                           opacity: isCompleted ? 0.6 : 1
//                         }}
//                       >
//                         <td>{index + 1}</td>
//                         <td>{shipment.SCPM_Name}</td>
//                         <td>{shipment.SHPD_ProductName}</td>
//                         <td>{shipment.SHPD_ProductCode}</td>
//                         <td>{shipment.inv_availableqty}</td>
//                         <td>{shipment.SHPD_ScanQty}</td>
//                         <td>{shipment.SHPD_ShipQty}</td>
//                       </tr>
//                     );
//                   })}
//                </tbody>
//               </table>
//               {SelectedProduct && selectedShipmentsBySCP.length === 0 && (
//                 <div>
//                   No ShipmentsBySCP available for the selected SCPM_Name
//                 </div>
//               )}
//             </div>
//           </div>

//           <div className="col-md-3">
//             <div className="scanContainer">
//                <p className="scannedHeading">Scanned RSN List</p>
//                <div>
//                  <input
//                    className="form-check-input"
//                    type="checkbox"
//                    id="selectAll"
//                    onChange={handleSelectAllChange}
//                  />
//                  <label className="form-check-label" htmlFor="selectAll">
//                    Select All
//                  </label>
//                </div>
//                {[...new Set(RSN.split("\n").filter((line) => line.trim() !== ""))].map(
//                  (line, index) => (
//                    <div key={index}>
//                      {/* <label>{line}</label> */}
//                    </div>
//                  )
//                )}
//                {/* Deduplicated RSN tree */}
//                {rsnTree &&
//                  rsnTree.map((rootNode) =>
//                    renderRSNNode(rootNode, 0, rootNode.isRoot)
//                  )}
//              </div>

//           </div>
//           <div className="button-container mt-2">
//             <button
//               onClick={removeSelectedItemsAndUpdateStatus}
//               className="scan_btn"
//             >
//               REMOVE SELECTED
//             </button>
//           </div>
//         </div>
//       </div>
//       <div className="button-container">
//         {isSaveButtonVisible() && (
//           <button
//             className="save_btn"
//             onClick={handleSave}
//             disabled={
//               isSaveButtonDisabled || (!SelectedProduct && !manualInputEnabled)
//             }
//           >
//             SAVE
//           </button>
//         )}

//         {isPopupVisible && (
//           <div className="popup-box">
//             <div className="popup-content-Suspend">
//               <h5 className="Suspend-Popup-Heading">:: User Confirmation ::</h5>
//               <p className="Suspend-Popup-Text">{message}</p>
//               <div>
//                 <button
//                   className="button-Confirm-Popup"
//                   onClick={handlePopupConfirm}
//                 >
//                   YES
//                 </button>
//                 <button
//                   className="button-Close-Popup"
//                   onClick={handlePopupClose}
//                 >
//                   NO
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       {isSpecialPopupVisible && (
//   <div className="popup-overlay">
//     <div className="popup-content special-scheme-popup">
//       <div className="popup-header">
//         <h5>🎁 Special Scheme Alert</h5>
//       </div>
//       <div className="popup-body">
//         <p style={{ 
//           whiteSpace: 'pre-line', 
//           textAlign: 'left',
//           fontSize: '14px',
//           lineHeight: '1.5'
//         }}>
//           {specialPopupMessage}
//         </p>
//       </div>
//       <div className="popup-footer">
//         <button
//           className="btn btn-primary"
//           onClick={() => setIsSpecialPopupVisible(false)}
//           style={{ padding: '8px 20px' }}
//         >
//           Understood
//         </button>
//       </div>
//     </div>
//   </div>
// )}
//         <Link 
//         to={`/ShipOutScanPendingList`} 
//         className="back_btn" 
//         type="button"
//         onClick={() => sessionStorage.removeItem('shipmentTableData')}
//         >
//           LIST
//         </Link>
//       </div>
//     </>
//   );
// }

// export default ShipOutScanByVendor;




